/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type NotificationResponse = {
  __typename: "NotificationResponse",
  msg?: string | null,
  habitatID?: string | null,
};

export type CreateAlarmInput = {
  id?: string | null,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  color?: string | null,
  reminders?: string | null,
};

// Types of CalendarItems
export enum CalendarItemType {
  Alarm = "Alarm", // An alarm that is triggered on the phone
  Alert = "Alert", // An alert/popup
  Event = "Event", // An event
  Goal = "Goal", // A goal
  Meal = "Meal", // A meal
}


export type RRuleInput = {
  mode: string,
  freq: number,
  interval?: number | null,
  byweekday?: Array< number | null > | null,
  until?: string | null,
  count?: number | null,
};

export type ModelAlarmConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  color?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelAlarmConditionInput | null > | null,
  or?: Array< ModelAlarmConditionInput | null > | null,
  not?: ModelAlarmConditionInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelCalendarItemTypeInput = {
  eq?: CalendarItemType | null,
  ne?: CalendarItemType | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type Alarm = {
  __typename: "Alarm",
  id: string,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  // Recurrence Rule Stored as a string
  recurrence_rule?: string | null,
  // Legacy Recurrence Rule Object
  recurrence?: RRule | null,
  // Stored as its own field for querying
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  // List of recurrence ids that have been deleted
  recurrenceExcludeDates?: string | null,
  // who is it for
  participantIDS?: Array< string | null > | null,
  // what needs to happen
  checklist?: string | null,
  notes?: string | null,
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  imageURL?: string | null,
  color?: string | null,
  // how and when do you want to be reminded about this alarm
  reminders?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type CalendarItem = {
  __typename: "CalendarItem",
  // unique identifier for calendar items
  id: string,
  // tenant identifies the household or group to which a calendar item belongs
  habitatID?: string | null,
  // emoji - options icon that can be associated with a calendar item
  emoji?: string | null,
  // title - mandatory titl for
  title: string,
  // type
  type?: CalendarItemType | null,
  // (required) the start time for a calendar item
  start: string,
  // recurrence - optional
  recurrence?: RRule | null,
  recurrenceInstanceMap?: string | null,
  // notes
  notes?: string | null,
  // Custom image ID
  imageID?: string | null,
  // Public Image URL
  imageURL?: string | null,
};

export type Alert = {
  __typename: "Alert",
  id: string,
  habitatID: string,
  emoji?: string | null,
  title: string,
  // Alert
  type?: CalendarItemType | null,
  // The start time for the alert
  start: string,
  // Recurrence Rule Stored as a string
  recurrence_rule?: string | null,
  // Legacy Recurrence Rule Object
  recurrence?: RRule | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  // List of recurrence ids that have been deleted
  recurrenceExcludeDates?: string | null,
  // IDS of user participating in the alert
  participantIDS?: Array< string | null > | null,
  // what needs to happen
  checklist?: string | null,
  // Notes on the alert
  notes?: string | null,
  // Image for the alert
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  imageURL?: string | null,
  // Set if this reminder is for a goal
  goalID?: string | null,
  goal?: Goal | null,
  color?: string | null,
  // how and when do you want to be reminded about this alert
  reminders?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type RRule = {
  __typename: "RRule",
  // The identifier for types of recurrence rules in the app
  mode: string,
  // Daily, Weekly, Yearly etc
  freq: number,
  // Every X days, weeks, months etc
  interval?: number | null,
  // Days of the week that it applies
  byweekday?: Array< number | null > | null,
  // Date to end the recurrence rule
  until?: string | null,
  // Number of recurrences that should occur
  count?: number | null,
};

export type Image = {
  __typename: "Image",
  id: string,
  name: string,
  habitatID?: string | null,
  readGroups?: Array< string | null > | null,
  // Data for linking to the S3 image
  data: S3Object,
  thumbnail?: S3Object | null,
  createdAt: string,
  updatedAt: string,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
};

export type Goal = {
  __typename: "Goal",
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  end?: string | null,
  allDay?: boolean | null,
  recurrence?: RRule | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  // List of recurrence ids that have been deleted
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  // who is it for
  principal?: User | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  // what do you need to bring
  checklist?: string | null,
  todo?: string | null,
  notes?: string | null,
  complete?: string | null,
  // A map of recurrence ids to their completion state.
  recurrenceCompletionStates?: string | null,
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  imageURL?: string | null,
  completions?: string | null,
  completions_per_period?: number | null,
  period?: GoalPeriod | null,
  // Reference code can be used to easily query the goal from bot actions and other app events
  reference_code?: string | null,
  // Groups that can read this Goal
  readGroups?: Array< string | null > | null,
  // Indicates that the goal is a template
  isTemplate?: boolean | null,
  // IDs that link to the options for goal categories
  category_ids?: Array< string | null > | null,
  // A hex code color for the goal. Is also used on alerts linked to the goal
  color?: string | null,
  // Owner of the Goal
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type User = {
  __typename: "User",
  // The ID of the user
  id: string,
  // The cognito user sub
  sub: string,
  // Name of the user
  name: string,
  // Location of the user
  location?: string | null,
  // The username of the user. This should come from the cognito user pool
  username: string,
  // Indicates that this user is the primary habitat user. This user cannot be deleted.
  primary?: boolean | null,
  // The Habitat the user belongs to. May not be set when account is still being set up
  habitatID?: string | null,
  role?: UserRole | null,
  // Email of the user
  email?: string | null,
  // The users phone number
  phoneNumber?: string | null,
  NDISAccountName?: string | null,
  NDISNumber?: string | null,
  birthday?: string | null,
  planManagerName?: string | null,
  planManagerEmail?: string | null,
  emailVerified?: boolean | null,
  carerPhone?: string | null,
  carerName?: string | null,
  supportWorkerPhone?: string | null,
  supportWorkerName?: string | null,
  contacts?: Array< string | null > | null,
  favouriteContacts?: Array< string | null > | null,
  address?: Address | null,
  // Profile color to be displayed with the users image
  profileColor?: string | null,
  // Selected Profile Picture - Stock Images from akin
  profilePicture?: string | null,
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  customPictureURL?: string | null,
  // Preferences linked to device system settings
  systemPreferences?: SystemPreferences | null,
  scheduledMessages?: ModelUserScheduledMessageConnection | null,
  endpointIds?: Array< string | null > | null,
  // Flag for whether the user has completed the meal onboarding
  hasCompletedMealOnboarding?: boolean | null,
  // Flag for whether the user has viewed the meals section of the app
  hasViewedMealSection?: boolean | null,
  // Flag for whether the user has viewed the goal section of the app
  hasViewedGoalSection?: boolean | null,
  // IDs of recipe preference options
  recipePreferenceOptionIDs?: Array< string | null > | null,
  // Token used when sending a link to the onboarding process
  onboardingToken?: string | null,
  // Flag for whether the user has been onboarded
  hasOnboarded?: boolean | null,
  // Flag for if the user has skipped the onboarding wizard
  skippedOnboardingWizard?: boolean | null,
  // The user's recipe choices in onboarding. A list of recipe IDs
  onboardingRecipeChoices?: Array< string | null > | null,
  // Dashboard Layout Preset
  dashboardLayoutPreset?: string | null,
  chatApplicationId?: string | null,
  people?: number | null,
  budget?: number | null,
  time_and_effort?: number | null,
  dietary_balance?: number | null,
  allergies?: Array< string | null > | null,
  prepTime?: number | null,
  avoidances?:  Array<FoodAvoidance | null > | null,
  skillLevel?: number | null,
  // Indicates that this is profile is for a child
  is_child_profile?: boolean | null,
  // If defined, this is passed to chat system to enable user to use generative AI as a fallback
  use_generative_ai?: UseGenerativeAIOptions | null,
  // List of the users favourite recipe IDs
  favourite_recipe_ids?: Array< string | null > | null,
  // ID of the linked contact record
  contact_id?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum UserRole {
  manager = "manager", // A household manager
  member = "member", // A household member
}


export type Address = {
  __typename: "Address",
  type?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  postcode?: string | null,
  country?: string | null,
};

export type SystemPreferences = {
  __typename: "SystemPreferences",
  androidNotificationSoundID?: string | null,
  androidAlarmSoundID?: string | null,
};

export type ModelUserScheduledMessageConnection = {
  __typename: "ModelUserScheduledMessageConnection",
  items:  Array<UserScheduledMessage | null >,
  nextToken?: string | null,
};

export type UserScheduledMessage = {
  __typename: "UserScheduledMessage",
  id: string,
  userID: string,
  habitatID: string,
  scheduledMessageID: string,
  scheduledMessage?: ScheduledMessage | null,
  scheduledDate?: string | null,
  scheduledTime: string,
  answered?: boolean | null,
  delayCount?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ScheduledMessage = {
  __typename: "ScheduledMessage",
  id: string,
  dialogTrigger: string,
  rrule?: string | null,
  periodOffset?: number | null,
  scheduledDate?: string | null,
  scheduledTime?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type FoodAvoidance = {
  __typename: "FoodAvoidance",
  category?: string | null,
  degree?: number | null,
};

export type UseGenerativeAIOptions = {
  __typename: "UseGenerativeAIOptions",
  name?: string | null,
  model?: string | null,
  max_tokens?: number | null,
  temperature?: number | null,
};

export enum GoalPeriod {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}


export type Event = {
  __typename: "Event",
  id: string,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  end: string,
  allDay?: boolean | null,
  // Recurrence Rule Stored as a string
  recurrence_rule?: string | null,
  // Legacy Recurrence Rule Object
  recurrence?: RRule | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  // List of recurrence ids that have been deleted
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  // who is it for
  principal?: User | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  // what do you need to bring
  checklist?: string | null,
  // what tasks do you need to do
  todo?: string | null,
  notes?: string | null,
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  imageURL?: string | null,
  color?: string | null,
  tags?: string | null,
  // how and when do you want to be reminded about this event
  reminders?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type Meal = {
  __typename: "Meal",
  id: string,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  mealType: MealType,
  start: string,
  end: string,
  recurrence?: RRule | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  // List of recurrence ids that have been deleted
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  // who is it for
  principal?: User | null,
  principalID?: string | null,
  // who else is going?
  participantIDS?: Array< string | null > | null,
  // Ingredients for the meal
  ingredients?:  Array<Ingredient | null > | null,
  // preparation notes or steps
  prepNotes?:  Array<PreparationNote | null > | null,
  notes?: string | null,
  // Uploaded Image
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // Public Image URL
  imageURL?: string | null,
  recipes?: ModelMealRecipeConnection | null,
  // Whether the meal was eaten
  eaten?: boolean | null,
  recommended?: boolean | null,
  acceptedRecommended?: boolean | null,
  // Indicates that this meal has been skipped. No recipe should be assigned to it.
  skipped?: boolean | null,
  // The meal plan this meal belongs to
  meal_plan_id?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export enum MealType {
  Breakfast = "Breakfast",
  Lunch = "Lunch",
  Dinner = "Dinner",
  Snack = "Snack",
}


export type Ingredient = {
  __typename: "Ingredient",
  id: string,
  title: string,
  checked: boolean,
  shoppingListID?: string | null,
};

export type PreparationNote = {
  __typename: "PreparationNote",
  id: string,
  title?: string | null,
  icon?: string | null,
  description: string,
};

export type ModelMealRecipeConnection = {
  __typename: "ModelMealRecipeConnection",
  items:  Array<MealRecipe | null >,
  nextToken?: string | null,
};

export type MealRecipe = {
  __typename: "MealRecipe",
  id: string,
  mealID: string,
  recipeID: string,
  recipe?: Recipe | null,
  createdAt: string,
  updatedAt: string,
};

export type Recipe = {
  __typename: "Recipe",
  id: string,
  // Habitat ID for a recipe. This means the recipe is linked to a specific household
  habitatID?: string | null,
  // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
  readGroups?: Array< string | null > | null,
  name: string,
  searchField?: string | null,
  emoji?: string | null,
  // A short description or introduction to the dish
  description?: string | null,
  imageUrl?: string | null,
  // Indicates the recipe is still in development
  inProgress?: boolean | null,
  imageID?: string | null,
  image?: Image | null,
  // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
  mealTypes?: Array< MealType | null > | null,
  dishTypeID?: string | null,
  // The type or category of the dish
  dishType?: Option | null,
  dishTypeIDs?: Array< string | null > | null,
  skillLevelID?: string | null,
  // The recommended skill level for the dish
  skillLevel?: Option | null,
  servingSizeID?: string | null,
  // How many servings this recipe provides
  servingSize?: Option | null,
  cuisineTypeID?: string | null,
  // How many servings this recipe provides
  cuisineType?: Option | null,
  familyfriendlyTypeID?: string | null,
  // How many servings this recipe provides
  familyfriendlyType?: Option | null,
  textureTypeID?: string | null,
  // How many servings this recipe provides
  textureType?: Option | null,
  specialDietIDs?: Array< string | null > | null,
  specialDiets?: ModelRecordOptionConnection | null,
  prepTimeID?: string | null,
  // Preparation time selection
  prepTime?: Option | null,
  // Preparation steps
  prepNotes?:  Array<PreparationNote | null > | null,
  mainIngredientID?: string | null,
  // The primary ingredient of the dish
  mainIngredient?: Option | null,
  // The health rating from 0-5
  health?: number | null,
  // Budget Rating
  budget?: number | null,
  // Utensils needed for the recipe
  utensils?: Array< string | null > | null,
  // List of ingredients
  ingredients?:  Array<RecipeIngredient | null > | null,
  recipeIngredients?: ModelRecipeIngredientsGroupConnection | null,
  // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
  allergyIDs?: Array< string | null > | null,
  // The default number of servings this recipe is for
  default_servings?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type Option = {
  __typename: "Option",
  id: string,
  // This type of option. This can be used to determine which dropdowns or lists the option can be used in
  type: string,
  // The displayed text for this option
  label: string,
  // Unique string code makes the option easier to reference and identify
  code: string,
  // Icons that may be displayed alongside the option
  icon?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelRecordOptionConnection = {
  __typename: "ModelRecordOptionConnection",
  items:  Array<RecordOption | null >,
  nextToken?: string | null,
};

export type RecordOption = {
  __typename: "RecordOption",
  id: string,
  recordID: string,
  optionID: string,
  option: Option,
  createdAt: string,
  updatedAt: string,
};

export type RecipeIngredient = {
  __typename: "RecipeIngredient",
  id: string,
  name: string,
  quantity?: string | null,
  unitOfMeasure?: string | null,
  category?: string | null,
  pantryItem?: boolean | null,
  ingredientID?: string | null,
};

export type ModelRecipeIngredientsGroupConnection = {
  __typename: "ModelRecipeIngredientsGroupConnection",
  items:  Array<RecipeIngredientsGroup | null >,
  nextToken?: string | null,
};

export type RecipeIngredientsGroup = {
  __typename: "RecipeIngredientsGroup",
  id: string,
  recipeID: string,
  // Optional display string for this ingredient
  display?: string | null,
  // The linked recipe
  recipe?: Recipe | null,
  ingredientID?: string | null,
  ingredient?: ModelIngredientItemConnection | null,
  quantity?: string | null,
  unitOfMeasure?: string | null,
  pantryItem?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelIngredientItemConnection = {
  __typename: "ModelIngredientItemConnection",
  items:  Array<IngredientItem | null >,
  nextToken?: string | null,
};

export type IngredientItem = {
  __typename: "IngredientItem",
  id: string,
  name: string,
  groupID: string,
  group?: IngredientGroup | null,
  recipeGroupID?: string | null,
  recipeGroup?: ModelRecipeIngredientsGroupConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type IngredientGroup = {
  __typename: "IngredientGroup",
  id: string,
  name: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateAlarmInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: CalendarItemType | null,
  start?: string | null,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  color?: string | null,
  reminders?: string | null,
};

export type DeleteAlarmInput = {
  id: string,
};

export type CreateAlertInput = {
  id?: string | null,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  goalID?: string | null,
  color?: string | null,
  reminders?: string | null,
};

export type ModelAlertConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  goalID?: ModelIDInput | null,
  color?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelAlertConditionInput | null > | null,
  or?: Array< ModelAlertConditionInput | null > | null,
  not?: ModelAlertConditionInput | null,
};

export type UpdateAlertInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: CalendarItemType | null,
  start?: string | null,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  goalID?: string | null,
  color?: string | null,
  reminders?: string | null,
};

export type DeleteAlertInput = {
  id: string,
};

export type CreateEventInput = {
  id?: string | null,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  end: string,
  allDay?: boolean | null,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  todo?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  color?: string | null,
  tags?: string | null,
  reminders?: string | null,
  eventPrincipalId?: string | null,
};

export type ModelEventConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  allDay?: ModelBooleanInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  todo?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  color?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateEventInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: CalendarItemType | null,
  start?: string | null,
  end?: string | null,
  allDay?: boolean | null,
  recurrence_rule?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  todo?: string | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  color?: string | null,
  tags?: string | null,
  reminders?: string | null,
  eventPrincipalId?: string | null,
};

export type DeleteEventInput = {
  id: string,
};

export type CreateMealInput = {
  id?: string | null,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  mealType: MealType,
  start: string,
  end: string,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  ingredients?: Array< IngredientInput | null > | null,
  prepNotes?: Array< PreparationNoteInput | null > | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  eaten?: boolean | null,
  recommended?: boolean | null,
  acceptedRecommended?: boolean | null,
  skipped?: boolean | null,
  meal_plan_id?: string | null,
  mealPrincipalId?: string | null,
};

export type IngredientInput = {
  id: string,
  title: string,
  checked: boolean,
  shoppingListID?: string | null,
};

export type PreparationNoteInput = {
  id: string,
  title?: string | null,
  icon?: string | null,
  description: string,
};

export type ModelMealConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  mealType?: ModelMealTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  eaten?: ModelBooleanInput | null,
  recommended?: ModelBooleanInput | null,
  acceptedRecommended?: ModelBooleanInput | null,
  skipped?: ModelBooleanInput | null,
  meal_plan_id?: ModelIDInput | null,
  and?: Array< ModelMealConditionInput | null > | null,
  or?: Array< ModelMealConditionInput | null > | null,
  not?: ModelMealConditionInput | null,
};

export type ModelMealTypeInput = {
  eq?: MealType | null,
  ne?: MealType | null,
};

export type UpdateMealInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: CalendarItemType | null,
  mealType?: MealType | null,
  start?: string | null,
  end?: string | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  ingredients?: Array< IngredientInput | null > | null,
  prepNotes?: Array< PreparationNoteInput | null > | null,
  notes?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  eaten?: boolean | null,
  recommended?: boolean | null,
  acceptedRecommended?: boolean | null,
  skipped?: boolean | null,
  meal_plan_id?: string | null,
  mealPrincipalId?: string | null,
};

export type DeleteMealInput = {
  id: string,
};

export type CreateMealRecipeInput = {
  id?: string | null,
  mealID: string,
  recipeID: string,
};

export type ModelMealRecipeConditionInput = {
  mealID?: ModelIDInput | null,
  recipeID?: ModelIDInput | null,
  and?: Array< ModelMealRecipeConditionInput | null > | null,
  or?: Array< ModelMealRecipeConditionInput | null > | null,
  not?: ModelMealRecipeConditionInput | null,
};

export type UpdateMealRecipeInput = {
  id: string,
  mealID?: string | null,
  recipeID?: string | null,
};

export type DeleteMealRecipeInput = {
  id: string,
};

export type CreateDashboardInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  device_type?: DashboardDeviceType | null,
  user_id?: string | null,
  read_accounts?: Array< string | null > | null,
  read_groups?: Array< string | null > | null,
  full_access_groups?: Array< string | null > | null,
  layout?: string | null,
  owner?: string | null,
};

export enum DashboardDeviceType {
  tablet = "tablet",
  mobile = "mobile",
}


export type ModelDashboardConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  device_type?: ModelDashboardDeviceTypeInput | null,
  user_id?: ModelIDInput | null,
  layout?: ModelStringInput | null,
  and?: Array< ModelDashboardConditionInput | null > | null,
  or?: Array< ModelDashboardConditionInput | null > | null,
  not?: ModelDashboardConditionInput | null,
};

export type ModelDashboardDeviceTypeInput = {
  eq?: DashboardDeviceType | null,
  ne?: DashboardDeviceType | null,
};

export type Dashboard = {
  __typename: "Dashboard",
  id: string,
  // Name of the dashboard
  name?: string | null,
  // Description of the dashboard
  description?: string | null,
  device_type?: DashboardDeviceType | null,
  // The user ID this dashboard is for
  user_id?: string | null,
  // Accounts allowed to read this
  read_accounts?: Array< string | null > | null,
  // Groups allowed to read this
  read_groups?: Array< string | null > | null,
  // Groups allowed to edit the dashboard
  full_access_groups?: Array< string | null > | null,
  // Data for linking to the S3 file
  layout?: string | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDashboardInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  device_type?: DashboardDeviceType | null,
  user_id?: string | null,
  read_accounts?: Array< string | null > | null,
  read_groups?: Array< string | null > | null,
  full_access_groups?: Array< string | null > | null,
  layout?: string | null,
  owner?: string | null,
};

export type DeleteDashboardInput = {
  id: string,
};

export type CreateDomainInput = {
  id?: string | null,
  name: string,
  parentDomainID?: string | null,
};

export type ModelDomainConditionInput = {
  name?: ModelStringInput | null,
  parentDomainID?: ModelIDInput | null,
  and?: Array< ModelDomainConditionInput | null > | null,
  or?: Array< ModelDomainConditionInput | null > | null,
  not?: ModelDomainConditionInput | null,
};

export type Domain = {
  __typename: "Domain",
  id: string,
  name: string,
  parentDomainID?: string | null,
  subDomains?: ModelDomainConnection | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelDomainConnection = {
  __typename: "ModelDomainConnection",
  items:  Array<Domain | null >,
  nextToken?: string | null,
};

export type UpdateDomainInput = {
  id: string,
  name?: string | null,
  parentDomainID?: string | null,
};

export type DeleteDomainInput = {
  id: string,
};

export type CreateFileInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  file_type: string,
  read_accounts?: Array< string | null > | null,
  read_groups?: Array< string | null > | null,
  full_access_groups?: Array< string | null > | null,
  data: S3ObjectInput,
  public?: boolean | null,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
};

export type ModelFileConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  file_type?: ModelStringInput | null,
  public?: ModelBooleanInput | null,
  and?: Array< ModelFileConditionInput | null > | null,
  or?: Array< ModelFileConditionInput | null > | null,
  not?: ModelFileConditionInput | null,
};

export type File = {
  __typename: "File",
  id: string,
  name: string,
  description?: string | null,
  // The file type. e.g. pdf, doc
  file_type: string,
  read_accounts?: Array< string | null > | null,
  read_groups?: Array< string | null > | null,
  full_access_groups?: Array< string | null > | null,
  // Data for linking to the S3 file
  data: S3Object,
  // File is publicly viewable
  public?: boolean | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateFileInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  file_type?: string | null,
  read_accounts?: Array< string | null > | null,
  read_groups?: Array< string | null > | null,
  full_access_groups?: Array< string | null > | null,
  data?: S3ObjectInput | null,
  public?: boolean | null,
};

export type DeleteFileInput = {
  id: string,
};

export type CreateGoalInput = {
  id?: string | null,
  habitatID?: string | null,
  emoji?: string | null,
  title: string,
  type?: CalendarItemType | null,
  start: string,
  end?: string | null,
  allDay?: boolean | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  todo?: string | null,
  notes?: string | null,
  complete?: string | null,
  recurrenceCompletionStates?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  completions?: string | null,
  completions_per_period?: number | null,
  period?: GoalPeriod | null,
  reference_code?: string | null,
  readGroups?: Array< string | null > | null,
  isTemplate?: boolean | null,
  category_ids?: Array< string | null > | null,
  color?: string | null,
  owner?: string | null,
  goalPrincipalId?: string | null,
};

export type ModelGoalConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  allDay?: ModelBooleanInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  todo?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  complete?: ModelStringInput | null,
  recurrenceCompletionStates?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  completions?: ModelStringInput | null,
  completions_per_period?: ModelIntInput | null,
  period?: ModelGoalPeriodInput | null,
  reference_code?: ModelStringInput | null,
  isTemplate?: ModelBooleanInput | null,
  category_ids?: ModelIDInput | null,
  color?: ModelStringInput | null,
  and?: Array< ModelGoalConditionInput | null > | null,
  or?: Array< ModelGoalConditionInput | null > | null,
  not?: ModelGoalConditionInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelGoalPeriodInput = {
  eq?: GoalPeriod | null,
  ne?: GoalPeriod | null,
};

export type UpdateGoalInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: CalendarItemType | null,
  start?: string | null,
  end?: string | null,
  allDay?: boolean | null,
  recurrence?: RRuleInput | null,
  recurrenceUntil?: string | null,
  recurrenceInstanceMap?: string | null,
  recurrenceExcludeDates?: string | null,
  location?: string | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  todo?: string | null,
  notes?: string | null,
  complete?: string | null,
  recurrenceCompletionStates?: string | null,
  imageID?: string | null,
  imageURL?: string | null,
  completions?: string | null,
  completions_per_period?: number | null,
  period?: GoalPeriod | null,
  reference_code?: string | null,
  readGroups?: Array< string | null > | null,
  isTemplate?: boolean | null,
  category_ids?: Array< string | null > | null,
  color?: string | null,
  owner?: string | null,
  goalPrincipalId?: string | null,
};

export type DeleteGoalInput = {
  id: string,
};

export type CreateHabitatInput = {
  id?: string | null,
  habitatID: string,
  name?: string | null,
  favouriteRecipeIDs?: Array< string | null > | null,
  imageID?: string | null,
  imageURL?: string | null,
};

export type ModelHabitatConditionInput = {
  name?: ModelStringInput | null,
  favouriteRecipeIDs?: ModelIDInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  and?: Array< ModelHabitatConditionInput | null > | null,
  or?: Array< ModelHabitatConditionInput | null > | null,
  not?: ModelHabitatConditionInput | null,
};

export type Habitat = {
  __typename: "Habitat",
  id: string,
  habitatID: string,
  name?: string | null,
  favouriteRecipes?: ModelRecipeFavouriteConnection | null,
  // This is the current way we are identifying favourite recipes. Much easier to work with local caching
  favouriteRecipeIDs?: Array< string | null > | null,
  // Image displayed on dashboard
  imageID?: string | null,
  image?: Image | null,
  imageURL?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelRecipeFavouriteConnection = {
  __typename: "ModelRecipeFavouriteConnection",
  items:  Array<RecipeFavourite | null >,
  nextToken?: string | null,
};

export type RecipeFavourite = {
  __typename: "RecipeFavourite",
  id: string,
  habitatID: string,
  recipeID: string,
  recipe: Recipe,
  createdAt: string,
  updatedAt: string,
};

export type UpdateHabitatInput = {
  id: string,
  habitatID?: string | null,
  name?: string | null,
  favouriteRecipeIDs?: Array< string | null > | null,
  imageID?: string | null,
  imageURL?: string | null,
};

export type DeleteHabitatInput = {
  id: string,
};

export type CreateRecipeFavouriteInput = {
  id?: string | null,
  habitatID: string,
  recipeID: string,
};

export type ModelRecipeFavouriteConditionInput = {
  habitatID?: ModelIDInput | null,
  recipeID?: ModelIDInput | null,
  and?: Array< ModelRecipeFavouriteConditionInput | null > | null,
  or?: Array< ModelRecipeFavouriteConditionInput | null > | null,
  not?: ModelRecipeFavouriteConditionInput | null,
};

export type UpdateRecipeFavouriteInput = {
  id: string,
  habitatID?: string | null,
  recipeID?: string | null,
};

export type DeleteRecipeFavouriteInput = {
  id: string,
};

export type CreateImageInput = {
  id?: string | null,
  name: string,
  habitatID?: string | null,
  readGroups?: Array< string | null > | null,
  data: S3ObjectInput,
  thumbnail?: S3ObjectInput | null,
};

export type ModelImageConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelImageConditionInput | null > | null,
  or?: Array< ModelImageConditionInput | null > | null,
  not?: ModelImageConditionInput | null,
};

export type UpdateImageInput = {
  id: string,
  name?: string | null,
  habitatID?: string | null,
  readGroups?: Array< string | null > | null,
  data?: S3ObjectInput | null,
  thumbnail?: S3ObjectInput | null,
};

export type DeleteImageInput = {
  id: string,
};

export type CreateIngredientGroupInput = {
  id?: string | null,
  name: string,
};

export type ModelIngredientGroupConditionInput = {
  name?: ModelStringInput | null,
  and?: Array< ModelIngredientGroupConditionInput | null > | null,
  or?: Array< ModelIngredientGroupConditionInput | null > | null,
  not?: ModelIngredientGroupConditionInput | null,
};

export type UpdateIngredientGroupInput = {
  id: string,
  name?: string | null,
};

export type DeleteIngredientGroupInput = {
  id: string,
};

export type CreateIngredientItemInput = {
  id?: string | null,
  name: string,
  groupID: string,
  recipeGroupID?: string | null,
};

export type ModelIngredientItemConditionInput = {
  name?: ModelStringInput | null,
  groupID?: ModelIDInput | null,
  recipeGroupID?: ModelIDInput | null,
  and?: Array< ModelIngredientItemConditionInput | null > | null,
  or?: Array< ModelIngredientItemConditionInput | null > | null,
  not?: ModelIngredientItemConditionInput | null,
};

export type UpdateIngredientItemInput = {
  id: string,
  name?: string | null,
  groupID?: string | null,
  recipeGroupID?: string | null,
};

export type DeleteIngredientItemInput = {
  id: string,
};

export type CreateLockPinInput = {
  user_id: string,
  pin?: string | null,
  prompt_new_pin?: boolean | null,
};

export type ModelLockPinConditionInput = {
  pin?: ModelStringInput | null,
  prompt_new_pin?: ModelBooleanInput | null,
  and?: Array< ModelLockPinConditionInput | null > | null,
  or?: Array< ModelLockPinConditionInput | null > | null,
  not?: ModelLockPinConditionInput | null,
};

export type LockPin = {
  __typename: "LockPin",
  user_id: string,
  pin?: string | null,
  prompt_new_pin?: boolean | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateLockPinInput = {
  user_id: string,
  pin?: string | null,
  prompt_new_pin?: boolean | null,
};

export type DeleteLockPinInput = {
  user_id: string,
};

export type CreateLogEventInput = {
  id?: string | null,
  type: LogEventType,
  source: LogEventSource,
  platform: LogEventPlatform,
  user_id?: string | null,
  feature_domain?: FeatureDomain | null,
  data?: string | null,
  createdAt?: string | null,
};

export enum LogEventType {
  PAGE_VIEW = "PAGE_VIEW", // A page is viewed
  APP_OPEN = "APP_OPEN", // An app is opened from within the Home AI app
  VIEW_RECORD = "VIEW_RECORD", // User viewed a record's details
  CREATE_RECORD = "CREATE_RECORD", // A record is created
  UPDATE_RECORD = "UPDATE_RECORD", // A record is updated
  DELETE_RECORD = "DELETE_RECORD", // A record is deleted
  SEND_AI_CHAT = "SEND_AI_CHAT", // User sends a message to AI
}


export enum LogEventSource {
  HOME_AI_APP = "HOME_AI_APP",
  HOME_AI_COMPANION_APP = "HOME_AI_COMPANION_APP",
}


export enum LogEventPlatform {
  ANDROID = "ANDROID",
  WEB = "WEB",
  IOS = "IOS",
}


export enum FeatureDomain {
  CALENDAR = "CALENDAR",
  GOALS = "GOALS",
  MEALS = "MEALS",
  CONTACTS = "CONTACTS",
  APPS = "APPS",
  CHECKLISTS = "CHECKLISTS",
  STICKY_NOTES = "STICKY_NOTES",
}


export type ModelLogEventConditionInput = {
  type?: ModelLogEventTypeInput | null,
  source?: ModelLogEventSourceInput | null,
  platform?: ModelLogEventPlatformInput | null,
  user_id?: ModelIDInput | null,
  feature_domain?: ModelFeatureDomainInput | null,
  data?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogEventConditionInput | null > | null,
  or?: Array< ModelLogEventConditionInput | null > | null,
  not?: ModelLogEventConditionInput | null,
};

export type ModelLogEventTypeInput = {
  eq?: LogEventType | null,
  ne?: LogEventType | null,
};

export type ModelLogEventSourceInput = {
  eq?: LogEventSource | null,
  ne?: LogEventSource | null,
};

export type ModelLogEventPlatformInput = {
  eq?: LogEventPlatform | null,
  ne?: LogEventPlatform | null,
};

export type ModelFeatureDomainInput = {
  eq?: FeatureDomain | null,
  ne?: FeatureDomain | null,
};

export type LogEvent = {
  __typename: "LogEvent",
  id: string,
  // The type of log event
  type: LogEventType,
  // Application the log came from
  source: LogEventSource,
  // Plaform type the log even originated
  platform: LogEventPlatform,
  // ID of the user account
  user_id?: string | null,
  feature_domain?: FeatureDomain | null,
  // Data is unique to each log event type
  data?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateLogEventInput = {
  id: string,
  type?: LogEventType | null,
  source?: LogEventSource | null,
  platform?: LogEventPlatform | null,
  user_id?: string | null,
  feature_domain?: FeatureDomain | null,
  data?: string | null,
  createdAt?: string | null,
};

export type DeleteLogEventInput = {
  id: string,
};

export type CreateMealPlanInput = {
  id?: string | null,
  habitatID?: string | null,
  week?: string | null,
};

export type ModelMealPlanConditionInput = {
  week?: ModelStringInput | null,
  and?: Array< ModelMealPlanConditionInput | null > | null,
  or?: Array< ModelMealPlanConditionInput | null > | null,
  not?: ModelMealPlanConditionInput | null,
};

export type MealPlan = {
  __typename: "MealPlan",
  id: string,
  habitatID?: string | null,
  week?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMealPlanInput = {
  id: string,
  habitatID?: string | null,
  week?: string | null,
};

export type DeleteMealPlanInput = {
  id: string,
};

export type CreateOptionInput = {
  id?: string | null,
  type: string,
  label: string,
  code: string,
  icon?: string | null,
};

export type ModelOptionConditionInput = {
  type?: ModelStringInput | null,
  label?: ModelStringInput | null,
  code?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  and?: Array< ModelOptionConditionInput | null > | null,
  or?: Array< ModelOptionConditionInput | null > | null,
  not?: ModelOptionConditionInput | null,
};

export type UpdateOptionInput = {
  id: string,
  type?: string | null,
  label?: string | null,
  code?: string | null,
  icon?: string | null,
};

export type DeleteOptionInput = {
  id: string,
};

export type CreateRecordOptionInput = {
  id?: string | null,
  recordID: string,
  optionID: string,
};

export type ModelRecordOptionConditionInput = {
  recordID?: ModelIDInput | null,
  optionID?: ModelIDInput | null,
  and?: Array< ModelRecordOptionConditionInput | null > | null,
  or?: Array< ModelRecordOptionConditionInput | null > | null,
  not?: ModelRecordOptionConditionInput | null,
};

export type UpdateRecordOptionInput = {
  id: string,
  recordID?: string | null,
  optionID?: string | null,
};

export type DeleteRecordOptionInput = {
  id: string,
};

export type CreateProfileInput = {
  id?: string | null,
  habitatID: string,
  userID?: string | null,
  name?: string | null,
  email?: string | null,
  role?: ProfileRole | null,
  imageID?: string | null,
  stockImage?: string | null,
};

export enum ProfileRole {
  manager = "manager",
  member = "member",
}


export type ModelProfileConditionInput = {
  userID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  role?: ModelProfileRoleInput | null,
  imageID?: ModelIDInput | null,
  stockImage?: ModelStringInput | null,
  and?: Array< ModelProfileConditionInput | null > | null,
  or?: Array< ModelProfileConditionInput | null > | null,
  not?: ModelProfileConditionInput | null,
};

export type ModelProfileRoleInput = {
  eq?: ProfileRole | null,
  ne?: ProfileRole | null,
};

export type Profile = {
  __typename: "Profile",
  id: string,
  habitatID: string,
  // ID of User that owns this profile
  userID?: string | null,
  name?: string | null,
  email?: string | null,
  role?: ProfileRole | null,
  imageID?: string | null,
  // Custom image uploaded from the device
  image?: Image | null,
  // A selected stock image
  stockImage?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateProfileInput = {
  id: string,
  habitatID?: string | null,
  userID?: string | null,
  name?: string | null,
  email?: string | null,
  role?: ProfileRole | null,
  imageID?: string | null,
  stockImage?: string | null,
};

export type DeleteProfileInput = {
  id: string,
};

export type CreateRecipeInput = {
  id?: string | null,
  habitatID?: string | null,
  readGroups?: Array< string | null > | null,
  name: string,
  searchField?: string | null,
  emoji?: string | null,
  description?: string | null,
  imageUrl?: string | null,
  inProgress?: boolean | null,
  imageID?: string | null,
  mealTypes?: Array< MealType | null > | null,
  dishTypeID?: string | null,
  dishTypeIDs?: Array< string | null > | null,
  skillLevelID?: string | null,
  servingSizeID?: string | null,
  cuisineTypeID?: string | null,
  familyfriendlyTypeID?: string | null,
  textureTypeID?: string | null,
  specialDietIDs?: Array< string | null > | null,
  prepTimeID?: string | null,
  prepNotes?: Array< PreparationNoteInput | null > | null,
  mainIngredientID?: string | null,
  health?: number | null,
  budget?: number | null,
  utensils?: Array< string | null > | null,
  ingredients?: Array< RecipeIngredientInput | null > | null,
  allergyIDs?: Array< string | null > | null,
  default_servings?: number | null,
};

export type RecipeIngredientInput = {
  id: string,
  name: string,
  quantity?: string | null,
  unitOfMeasure?: string | null,
  category?: string | null,
  pantryItem?: boolean | null,
  ingredientID?: string | null,
};

export type ModelRecipeConditionInput = {
  name?: ModelStringInput | null,
  searchField?: ModelStringInput | null,
  emoji?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  inProgress?: ModelBooleanInput | null,
  imageID?: ModelIDInput | null,
  mealTypes?: ModelMealTypeListInput | null,
  dishTypeID?: ModelIDInput | null,
  dishTypeIDs?: ModelIDInput | null,
  skillLevelID?: ModelIDInput | null,
  servingSizeID?: ModelIDInput | null,
  cuisineTypeID?: ModelIDInput | null,
  familyfriendlyTypeID?: ModelIDInput | null,
  textureTypeID?: ModelIDInput | null,
  specialDietIDs?: ModelIDInput | null,
  prepTimeID?: ModelIDInput | null,
  mainIngredientID?: ModelIDInput | null,
  health?: ModelIntInput | null,
  budget?: ModelIntInput | null,
  utensils?: ModelStringInput | null,
  allergyIDs?: ModelIDInput | null,
  default_servings?: ModelIntInput | null,
  and?: Array< ModelRecipeConditionInput | null > | null,
  or?: Array< ModelRecipeConditionInput | null > | null,
  not?: ModelRecipeConditionInput | null,
};

export type ModelMealTypeListInput = {
  eq?: Array< MealType | null > | null,
  ne?: Array< MealType | null > | null,
  contains?: MealType | null,
  notContains?: MealType | null,
};

export type UpdateRecipeInput = {
  id: string,
  habitatID?: string | null,
  readGroups?: Array< string | null > | null,
  name?: string | null,
  searchField?: string | null,
  emoji?: string | null,
  description?: string | null,
  imageUrl?: string | null,
  inProgress?: boolean | null,
  imageID?: string | null,
  mealTypes?: Array< MealType | null > | null,
  dishTypeID?: string | null,
  dishTypeIDs?: Array< string | null > | null,
  skillLevelID?: string | null,
  servingSizeID?: string | null,
  cuisineTypeID?: string | null,
  familyfriendlyTypeID?: string | null,
  textureTypeID?: string | null,
  specialDietIDs?: Array< string | null > | null,
  prepTimeID?: string | null,
  prepNotes?: Array< PreparationNoteInput | null > | null,
  mainIngredientID?: string | null,
  health?: number | null,
  budget?: number | null,
  utensils?: Array< string | null > | null,
  ingredients?: Array< RecipeIngredientInput | null > | null,
  allergyIDs?: Array< string | null > | null,
  default_servings?: number | null,
};

export type DeleteRecipeInput = {
  id: string,
};

export type CreateRecipeIngredientsGroupInput = {
  id?: string | null,
  recipeID: string,
  display?: string | null,
  ingredientID?: string | null,
  quantity?: string | null,
  unitOfMeasure?: string | null,
  pantryItem?: boolean | null,
};

export type ModelRecipeIngredientsGroupConditionInput = {
  recipeID?: ModelIDInput | null,
  display?: ModelStringInput | null,
  ingredientID?: ModelIDInput | null,
  quantity?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  pantryItem?: ModelBooleanInput | null,
  and?: Array< ModelRecipeIngredientsGroupConditionInput | null > | null,
  or?: Array< ModelRecipeIngredientsGroupConditionInput | null > | null,
  not?: ModelRecipeIngredientsGroupConditionInput | null,
};

export type UpdateRecipeIngredientsGroupInput = {
  id: string,
  recipeID?: string | null,
  display?: string | null,
  ingredientID?: string | null,
  quantity?: string | null,
  unitOfMeasure?: string | null,
  pantryItem?: boolean | null,
};

export type DeleteRecipeIngredientsGroupInput = {
  id: string,
};

export type CreateScheduledMessageInput = {
  id?: string | null,
  dialogTrigger: string,
  rrule?: string | null,
  periodOffset?: number | null,
  scheduledDate?: string | null,
  scheduledTime?: string | null,
};

export type ModelScheduledMessageConditionInput = {
  dialogTrigger?: ModelStringInput | null,
  rrule?: ModelStringInput | null,
  periodOffset?: ModelIntInput | null,
  scheduledDate?: ModelStringInput | null,
  scheduledTime?: ModelStringInput | null,
  and?: Array< ModelScheduledMessageConditionInput | null > | null,
  or?: Array< ModelScheduledMessageConditionInput | null > | null,
  not?: ModelScheduledMessageConditionInput | null,
};

export type UpdateScheduledMessageInput = {
  id: string,
  dialogTrigger?: string | null,
  rrule?: string | null,
  periodOffset?: number | null,
  scheduledDate?: string | null,
  scheduledTime?: string | null,
};

export type DeleteScheduledMessageInput = {
  id: string,
};

export type CreateStickyNoteInput = {
  id?: string | null,
  habitatID?: string | null,
  content?: string | null,
  color?: string | null,
  ownerID?: string | null,
  sharedWithIDs?: Array< string | null > | null,
  acknowledgements?: Array< StickyNoteAcknowledgementInput | null > | null,
};

export type StickyNoteAcknowledgementInput = {
  user_id?: string | null,
  date?: string | null,
};

export type ModelStickyNoteConditionInput = {
  content?: ModelStringInput | null,
  color?: ModelStringInput | null,
  ownerID?: ModelIDInput | null,
  sharedWithIDs?: ModelIDInput | null,
  and?: Array< ModelStickyNoteConditionInput | null > | null,
  or?: Array< ModelStickyNoteConditionInput | null > | null,
  not?: ModelStickyNoteConditionInput | null,
};

export type StickyNote = {
  __typename: "StickyNote",
  id: string,
  // Habitat the note belongs to
  habitatID?: string | null,
  // Content of the note
  content?: string | null,
  // Color of the note
  color?: string | null,
  // ID Person who created the note
  ownerID?: string | null,
  // Record of person who created the note
  owner?: User | null,
  // IDs of the users this note has been shared with
  sharedWithIDs?: Array< string | null > | null,
  // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
  acknowledgements?:  Array<StickyNoteAcknowledgement | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type StickyNoteAcknowledgement = {
  __typename: "StickyNoteAcknowledgement",
  user_id?: string | null,
  date?: string | null,
};

export type UpdateStickyNoteInput = {
  id: string,
  habitatID?: string | null,
  content?: string | null,
  color?: string | null,
  ownerID?: string | null,
  sharedWithIDs?: Array< string | null > | null,
  acknowledgements?: Array< StickyNoteAcknowledgementInput | null > | null,
};

export type DeleteStickyNoteInput = {
  id: string,
};

export type CreateSystemPropertyInput = {
  name: string,
  label: string,
  description?: string | null,
  value?: string | null,
  read_groups?: Array< string | null > | null,
  public?: boolean | null,
};

export type ModelSystemPropertyConditionInput = {
  label?: ModelStringInput | null,
  description?: ModelStringInput | null,
  value?: ModelStringInput | null,
  public?: ModelBooleanInput | null,
  and?: Array< ModelSystemPropertyConditionInput | null > | null,
  or?: Array< ModelSystemPropertyConditionInput | null > | null,
  not?: ModelSystemPropertyConditionInput | null,
};

export type SystemProperty = {
  __typename: "SystemProperty",
  // Primary Key
  name: string,
  // Display Label of the Property
  label: string,
  // Description of the property
  description?: string | null,
  // Value of the property
  value?: string | null,
  // Groups allowed to read this
  read_groups?: Array< string | null > | null,
  // System property is publicly viewable
  public?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateSystemPropertyInput = {
  name: string,
  label?: string | null,
  description?: string | null,
  value?: string | null,
  read_groups?: Array< string | null > | null,
  public?: boolean | null,
};

export type DeleteSystemPropertyInput = {
  name: string,
};

export type CreateTaskListInput = {
  id?: string | null,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: TaskListType | null,
  primaryIngredientList?: boolean | null,
  top?: boolean | null,
  favourite?: boolean | null,
  isAkinList?: boolean | null,
  principalID: string,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  image?: string | null,
  owner?: string | null,
};

// Types of TaskLists
export enum TaskListType {
  Shopping = "Shopping",
  ToDo = "ToDo",
  Checklist = "Checklist",
}


export type ModelTaskListConditionInput = {
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelTaskListTypeInput | null,
  primaryIngredientList?: ModelBooleanInput | null,
  top?: ModelBooleanInput | null,
  favourite?: ModelBooleanInput | null,
  isAkinList?: ModelBooleanInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  image?: ModelStringInput | null,
  and?: Array< ModelTaskListConditionInput | null > | null,
  or?: Array< ModelTaskListConditionInput | null > | null,
  not?: ModelTaskListConditionInput | null,
};

export type ModelTaskListTypeInput = {
  eq?: TaskListType | null,
  ne?: TaskListType | null,
};

export type TaskList = {
  __typename: "TaskList",
  id: string,
  habitatID: string,
  emoji?: string | null,
  title: string,
  type?: TaskListType | null,
  // Indicates that this list is the primary ingredients list.
  // This is the list that will have ingredients added to it from recipes etc
  primaryIngredientList?: boolean | null,
  top?: boolean | null,
  favourite?: boolean | null,
  isAkinList?: boolean | null,
  // who is it for
  principal: User,
  principalID: string,
  participantIDS?: Array< string | null > | null,
  // what do you need to bring
  checklist?: string | null,
  image?: string | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTaskListInput = {
  id: string,
  habitatID?: string | null,
  emoji?: string | null,
  title?: string | null,
  type?: TaskListType | null,
  primaryIngredientList?: boolean | null,
  top?: boolean | null,
  favourite?: boolean | null,
  isAkinList?: boolean | null,
  principalID?: string | null,
  participantIDS?: Array< string | null > | null,
  checklist?: string | null,
  image?: string | null,
  owner?: string | null,
};

export type DeleteTaskListInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  sub: string,
  name: string,
  location?: string | null,
  username: string,
  primary?: boolean | null,
  habitatID?: string | null,
  role?: UserRole | null,
  email?: string | null,
  phoneNumber?: string | null,
  NDISAccountName?: string | null,
  NDISNumber?: string | null,
  birthday?: string | null,
  planManagerName?: string | null,
  planManagerEmail?: string | null,
  emailVerified?: boolean | null,
  carerPhone?: string | null,
  carerName?: string | null,
  supportWorkerPhone?: string | null,
  supportWorkerName?: string | null,
  contacts?: Array< string | null > | null,
  favouriteContacts?: Array< string | null > | null,
  address?: AddressInput | null,
  profileColor?: string | null,
  profilePicture?: string | null,
  imageID?: string | null,
  customPictureURL?: string | null,
  systemPreferences?: SystemPreferencesInput | null,
  endpointIds?: Array< string | null > | null,
  hasCompletedMealOnboarding?: boolean | null,
  hasViewedMealSection?: boolean | null,
  hasViewedGoalSection?: boolean | null,
  recipePreferenceOptionIDs?: Array< string | null > | null,
  onboardingToken?: string | null,
  hasOnboarded?: boolean | null,
  skippedOnboardingWizard?: boolean | null,
  onboardingRecipeChoices?: Array< string | null > | null,
  dashboardLayoutPreset?: string | null,
  chatApplicationId?: string | null,
  people?: number | null,
  budget?: number | null,
  time_and_effort?: number | null,
  dietary_balance?: number | null,
  allergies?: Array< string | null > | null,
  prepTime?: number | null,
  avoidances?: Array< FoodAvoidanceInput | null > | null,
  skillLevel?: number | null,
  is_child_profile?: boolean | null,
  use_generative_ai?: UseGenerativeAIOptionsInput | null,
  favourite_recipe_ids?: Array< string | null > | null,
  contact_id?: string | null,
};

export type AddressInput = {
  type?: string | null,
  street?: string | null,
  city?: string | null,
  state?: string | null,
  postcode?: string | null,
  country?: string | null,
};

export type SystemPreferencesInput = {
  androidNotificationSoundID?: string | null,
  androidAlarmSoundID?: string | null,
};

export type FoodAvoidanceInput = {
  category?: string | null,
  degree?: number | null,
};

export type UseGenerativeAIOptionsInput = {
  name?: string | null,
  model?: string | null,
  max_tokens?: number | null,
  temperature?: number | null,
};

export type ModelUserConditionInput = {
  sub?: ModelIDInput | null,
  name?: ModelStringInput | null,
  location?: ModelStringInput | null,
  username?: ModelStringInput | null,
  primary?: ModelBooleanInput | null,
  role?: ModelUserRoleInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  NDISAccountName?: ModelStringInput | null,
  NDISNumber?: ModelStringInput | null,
  birthday?: ModelStringInput | null,
  planManagerName?: ModelStringInput | null,
  planManagerEmail?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  carerPhone?: ModelStringInput | null,
  carerName?: ModelStringInput | null,
  supportWorkerPhone?: ModelStringInput | null,
  supportWorkerName?: ModelStringInput | null,
  contacts?: ModelIDInput | null,
  favouriteContacts?: ModelIDInput | null,
  profileColor?: ModelStringInput | null,
  profilePicture?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  customPictureURL?: ModelStringInput | null,
  endpointIds?: ModelStringInput | null,
  hasCompletedMealOnboarding?: ModelBooleanInput | null,
  hasViewedMealSection?: ModelBooleanInput | null,
  hasViewedGoalSection?: ModelBooleanInput | null,
  recipePreferenceOptionIDs?: ModelStringInput | null,
  onboardingToken?: ModelIDInput | null,
  hasOnboarded?: ModelBooleanInput | null,
  skippedOnboardingWizard?: ModelBooleanInput | null,
  onboardingRecipeChoices?: ModelStringInput | null,
  dashboardLayoutPreset?: ModelStringInput | null,
  chatApplicationId?: ModelStringInput | null,
  people?: ModelIntInput | null,
  budget?: ModelIntInput | null,
  time_and_effort?: ModelIntInput | null,
  dietary_balance?: ModelIntInput | null,
  allergies?: ModelStringInput | null,
  prepTime?: ModelIntInput | null,
  skillLevel?: ModelIntInput | null,
  is_child_profile?: ModelBooleanInput | null,
  favourite_recipe_ids?: ModelIDInput | null,
  contact_id?: ModelIDInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelUserRoleInput = {
  eq?: UserRole | null,
  ne?: UserRole | null,
};

export type UpdateUserInput = {
  id: string,
  sub?: string | null,
  name?: string | null,
  location?: string | null,
  username?: string | null,
  primary?: boolean | null,
  habitatID?: string | null,
  role?: UserRole | null,
  email?: string | null,
  phoneNumber?: string | null,
  NDISAccountName?: string | null,
  NDISNumber?: string | null,
  birthday?: string | null,
  planManagerName?: string | null,
  planManagerEmail?: string | null,
  emailVerified?: boolean | null,
  carerPhone?: string | null,
  carerName?: string | null,
  supportWorkerPhone?: string | null,
  supportWorkerName?: string | null,
  contacts?: Array< string | null > | null,
  favouriteContacts?: Array< string | null > | null,
  address?: AddressInput | null,
  profileColor?: string | null,
  profilePicture?: string | null,
  imageID?: string | null,
  customPictureURL?: string | null,
  systemPreferences?: SystemPreferencesInput | null,
  endpointIds?: Array< string | null > | null,
  hasCompletedMealOnboarding?: boolean | null,
  hasViewedMealSection?: boolean | null,
  hasViewedGoalSection?: boolean | null,
  recipePreferenceOptionIDs?: Array< string | null > | null,
  onboardingToken?: string | null,
  hasOnboarded?: boolean | null,
  skippedOnboardingWizard?: boolean | null,
  onboardingRecipeChoices?: Array< string | null > | null,
  dashboardLayoutPreset?: string | null,
  chatApplicationId?: string | null,
  people?: number | null,
  budget?: number | null,
  time_and_effort?: number | null,
  dietary_balance?: number | null,
  allergies?: Array< string | null > | null,
  prepTime?: number | null,
  avoidances?: Array< FoodAvoidanceInput | null > | null,
  skillLevel?: number | null,
  is_child_profile?: boolean | null,
  use_generative_ai?: UseGenerativeAIOptionsInput | null,
  favourite_recipe_ids?: Array< string | null > | null,
  contact_id?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateContactInput = {
  id?: string | null,
  habitatID: string,
  name: string,
  type?: string | null,
  tags?: Array< string | null > | null,
  phoneNumbers?: Array< PhoneNumberInput | null > | null,
  emailAddresses?: Array< string | null > | null,
  addresses?: Array< AddressInput | null > | null,
  notes?: Array< string | null > | null,
  contactColor?: string | null,
  stockImage?: string | null,
  imageID?: string | null,
  publicImageURL?: string | null,
  user_id?: string | null,
};

export type PhoneNumberInput = {
  number: string,
  type: string,
};

export type ModelContactConditionInput = {
  name?: ModelStringInput | null,
  type?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  emailAddresses?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  contactColor?: ModelStringInput | null,
  stockImage?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  publicImageURL?: ModelStringInput | null,
  user_id?: ModelIDInput | null,
  and?: Array< ModelContactConditionInput | null > | null,
  or?: Array< ModelContactConditionInput | null > | null,
  not?: ModelContactConditionInput | null,
};

export type Contact = {
  __typename: "Contact",
  id: string,
  habitatID: string,
  name: string,
  // Don't use the type field anymore
  type?: string | null,
  tags?: Array< string | null > | null,
  phoneNumbers?:  Array<PhoneNumber | null > | null,
  emailAddresses?: Array< string | null > | null,
  addresses?:  Array<Address | null > | null,
  notes?: Array< string | null > | null,
  // Profile color to be displayed with the contact's image
  contactColor?: string | null,
  // Selected Contact Picture - Stock Images from akin
  stockImage?: string | null,
  imageID?: string | null,
  // Custom contact image uploaded from the device
  image?: Image | null,
  // Public Image URL
  publicImageURL?: string | null,
  // ID of the linked user record
  user_id?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type PhoneNumber = {
  __typename: "PhoneNumber",
  number: string,
  type: string,
};

export type UpdateContactInput = {
  id: string,
  habitatID?: string | null,
  name?: string | null,
  type?: string | null,
  tags?: Array< string | null > | null,
  phoneNumbers?: Array< PhoneNumberInput | null > | null,
  emailAddresses?: Array< string | null > | null,
  addresses?: Array< AddressInput | null > | null,
  notes?: Array< string | null > | null,
  contactColor?: string | null,
  stockImage?: string | null,
  imageID?: string | null,
  publicImageURL?: string | null,
  user_id?: string | null,
};

export type DeleteContactInput = {
  id: string,
};

export type CreateUserScheduledMessageInput = {
  id?: string | null,
  userID: string,
  habitatID: string,
  scheduledMessageID: string,
  scheduledDate?: string | null,
  scheduledTime: string,
  answered?: boolean | null,
  delayCount?: number | null,
};

export type ModelUserScheduledMessageConditionInput = {
  userID?: ModelIDInput | null,
  scheduledMessageID?: ModelIDInput | null,
  scheduledDate?: ModelStringInput | null,
  scheduledTime?: ModelStringInput | null,
  answered?: ModelBooleanInput | null,
  delayCount?: ModelIntInput | null,
  and?: Array< ModelUserScheduledMessageConditionInput | null > | null,
  or?: Array< ModelUserScheduledMessageConditionInput | null > | null,
  not?: ModelUserScheduledMessageConditionInput | null,
};

export type UpdateUserScheduledMessageInput = {
  id: string,
  userID?: string | null,
  habitatID?: string | null,
  scheduledMessageID?: string | null,
  scheduledDate?: string | null,
  scheduledTime?: string | null,
  answered?: boolean | null,
  delayCount?: number | null,
};

export type DeleteUserScheduledMessageInput = {
  id: string,
};

export type ModelAlarmFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  color?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelAlarmFilterInput | null > | null,
  or?: Array< ModelAlarmFilterInput | null > | null,
  not?: ModelAlarmFilterInput | null,
};

export type ModelAlarmConnection = {
  __typename: "ModelAlarmConnection",
  items:  Array<Alarm | null >,
  nextToken?: string | null,
};

export type ModelAlertFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  goalID?: ModelIDInput | null,
  color?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelAlertFilterInput | null > | null,
  or?: Array< ModelAlertFilterInput | null > | null,
  not?: ModelAlertFilterInput | null,
};

export type ModelAlertConnection = {
  __typename: "ModelAlertConnection",
  items:  Array<Alert | null >,
  nextToken?: string | null,
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  allDay?: ModelBooleanInput | null,
  recurrence_rule?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  todo?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  color?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  reminders?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
};

export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items:  Array<Event | null >,
  nextToken?: string | null,
};

export type ModelMealFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  mealType?: ModelMealTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  eaten?: ModelBooleanInput | null,
  recommended?: ModelBooleanInput | null,
  acceptedRecommended?: ModelBooleanInput | null,
  skipped?: ModelBooleanInput | null,
  meal_plan_id?: ModelIDInput | null,
  and?: Array< ModelMealFilterInput | null > | null,
  or?: Array< ModelMealFilterInput | null > | null,
  not?: ModelMealFilterInput | null,
};

export type ModelMealConnection = {
  __typename: "ModelMealConnection",
  items:  Array<Meal | null >,
  nextToken?: string | null,
};

export type ModelDashboardFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  device_type?: ModelDashboardDeviceTypeInput | null,
  user_id?: ModelIDInput | null,
  read_accounts?: ModelStringInput | null,
  read_groups?: ModelStringInput | null,
  full_access_groups?: ModelStringInput | null,
  layout?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelDashboardFilterInput | null > | null,
  or?: Array< ModelDashboardFilterInput | null > | null,
  not?: ModelDashboardFilterInput | null,
};

export type ModelDashboardConnection = {
  __typename: "ModelDashboardConnection",
  items:  Array<Dashboard | null >,
  nextToken?: string | null,
};

export type ModelDomainFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  parentDomainID?: ModelIDInput | null,
  and?: Array< ModelDomainFilterInput | null > | null,
  or?: Array< ModelDomainFilterInput | null > | null,
  not?: ModelDomainFilterInput | null,
};

export type ModelFileFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  file_type?: ModelStringInput | null,
  read_accounts?: ModelStringInput | null,
  read_groups?: ModelStringInput | null,
  full_access_groups?: ModelStringInput | null,
  public?: ModelBooleanInput | null,
  and?: Array< ModelFileFilterInput | null > | null,
  or?: Array< ModelFileFilterInput | null > | null,
  not?: ModelFileFilterInput | null,
};

export type ModelFileConnection = {
  __typename: "ModelFileConnection",
  items:  Array<File | null >,
  nextToken?: string | null,
};

export type ModelGoalFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelCalendarItemTypeInput | null,
  start?: ModelStringInput | null,
  end?: ModelStringInput | null,
  allDay?: ModelBooleanInput | null,
  recurrenceUntil?: ModelStringInput | null,
  recurrenceInstanceMap?: ModelStringInput | null,
  recurrenceExcludeDates?: ModelStringInput | null,
  location?: ModelStringInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  todo?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  complete?: ModelStringInput | null,
  recurrenceCompletionStates?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  completions?: ModelStringInput | null,
  completions_per_period?: ModelIntInput | null,
  period?: ModelGoalPeriodInput | null,
  reference_code?: ModelStringInput | null,
  readGroups?: ModelStringInput | null,
  isTemplate?: ModelBooleanInput | null,
  category_ids?: ModelIDInput | null,
  color?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelGoalFilterInput | null > | null,
  or?: Array< ModelGoalFilterInput | null > | null,
  not?: ModelGoalFilterInput | null,
};

export type ModelGoalConnection = {
  __typename: "ModelGoalConnection",
  items:  Array<Goal | null >,
  nextToken?: string | null,
};

export type ModelHabitatFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  favouriteRecipeIDs?: ModelIDInput | null,
  imageID?: ModelIDInput | null,
  imageURL?: ModelStringInput | null,
  and?: Array< ModelHabitatFilterInput | null > | null,
  or?: Array< ModelHabitatFilterInput | null > | null,
  not?: ModelHabitatFilterInput | null,
};

export type ModelHabitatConnection = {
  __typename: "ModelHabitatConnection",
  items:  Array<Habitat | null >,
  nextToken?: string | null,
};

export type ModelImageFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  habitatID?: ModelIDInput | null,
  readGroups?: ModelStringInput | null,
  and?: Array< ModelImageFilterInput | null > | null,
  or?: Array< ModelImageFilterInput | null > | null,
  not?: ModelImageFilterInput | null,
};

export type ModelImageConnection = {
  __typename: "ModelImageConnection",
  items:  Array<Image | null >,
  nextToken?: string | null,
};

export type ModelIngredientGroupFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelIngredientGroupFilterInput | null > | null,
  or?: Array< ModelIngredientGroupFilterInput | null > | null,
  not?: ModelIngredientGroupFilterInput | null,
};

export type ModelIngredientGroupConnection = {
  __typename: "ModelIngredientGroupConnection",
  items:  Array<IngredientGroup | null >,
  nextToken?: string | null,
};

export type ModelIngredientItemFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  groupID?: ModelIDInput | null,
  recipeGroupID?: ModelIDInput | null,
  and?: Array< ModelIngredientItemFilterInput | null > | null,
  or?: Array< ModelIngredientItemFilterInput | null > | null,
  not?: ModelIngredientItemFilterInput | null,
};

export type ModelLockPinFilterInput = {
  user_id?: ModelIDInput | null,
  pin?: ModelStringInput | null,
  prompt_new_pin?: ModelBooleanInput | null,
  and?: Array< ModelLockPinFilterInput | null > | null,
  or?: Array< ModelLockPinFilterInput | null > | null,
  not?: ModelLockPinFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelLockPinConnection = {
  __typename: "ModelLockPinConnection",
  items:  Array<LockPin | null >,
  nextToken?: string | null,
};

export type ModelLogEventFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelLogEventTypeInput | null,
  source?: ModelLogEventSourceInput | null,
  platform?: ModelLogEventPlatformInput | null,
  user_id?: ModelIDInput | null,
  feature_domain?: ModelFeatureDomainInput | null,
  data?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelLogEventFilterInput | null > | null,
  or?: Array< ModelLogEventFilterInput | null > | null,
  not?: ModelLogEventFilterInput | null,
};

export type ModelLogEventConnection = {
  __typename: "ModelLogEventConnection",
  items:  Array<LogEvent | null >,
  nextToken?: string | null,
};

export type ModelMealPlanFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  week?: ModelStringInput | null,
  and?: Array< ModelMealPlanFilterInput | null > | null,
  or?: Array< ModelMealPlanFilterInput | null > | null,
  not?: ModelMealPlanFilterInput | null,
};

export type ModelMealPlanConnection = {
  __typename: "ModelMealPlanConnection",
  items:  Array<MealPlan | null >,
  nextToken?: string | null,
};

export type ModelOptionFilterInput = {
  id?: ModelIDInput | null,
  type?: ModelStringInput | null,
  label?: ModelStringInput | null,
  code?: ModelStringInput | null,
  icon?: ModelStringInput | null,
  and?: Array< ModelOptionFilterInput | null > | null,
  or?: Array< ModelOptionFilterInput | null > | null,
  not?: ModelOptionFilterInput | null,
};

export type ModelOptionConnection = {
  __typename: "ModelOptionConnection",
  items:  Array<Option | null >,
  nextToken?: string | null,
};

export type ModelProfileFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  email?: ModelStringInput | null,
  role?: ModelProfileRoleInput | null,
  imageID?: ModelIDInput | null,
  stockImage?: ModelStringInput | null,
  and?: Array< ModelProfileFilterInput | null > | null,
  or?: Array< ModelProfileFilterInput | null > | null,
  not?: ModelProfileFilterInput | null,
};

export type ModelProfileConnection = {
  __typename: "ModelProfileConnection",
  items:  Array<Profile | null >,
  nextToken?: string | null,
};

export type ModelRecipeFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  readGroups?: ModelStringInput | null,
  name?: ModelStringInput | null,
  searchField?: ModelStringInput | null,
  emoji?: ModelStringInput | null,
  description?: ModelStringInput | null,
  imageUrl?: ModelStringInput | null,
  inProgress?: ModelBooleanInput | null,
  imageID?: ModelIDInput | null,
  mealTypes?: ModelMealTypeListInput | null,
  dishTypeID?: ModelIDInput | null,
  dishTypeIDs?: ModelIDInput | null,
  skillLevelID?: ModelIDInput | null,
  servingSizeID?: ModelIDInput | null,
  cuisineTypeID?: ModelIDInput | null,
  familyfriendlyTypeID?: ModelIDInput | null,
  textureTypeID?: ModelIDInput | null,
  specialDietIDs?: ModelIDInput | null,
  prepTimeID?: ModelIDInput | null,
  mainIngredientID?: ModelIDInput | null,
  health?: ModelIntInput | null,
  budget?: ModelIntInput | null,
  utensils?: ModelStringInput | null,
  allergyIDs?: ModelIDInput | null,
  default_servings?: ModelIntInput | null,
  and?: Array< ModelRecipeFilterInput | null > | null,
  or?: Array< ModelRecipeFilterInput | null > | null,
  not?: ModelRecipeFilterInput | null,
};

export type ModelRecipeConnection = {
  __typename: "ModelRecipeConnection",
  items:  Array<Recipe | null >,
  nextToken?: string | null,
};

export type ModelRecipeIngredientsGroupFilterInput = {
  id?: ModelIDInput | null,
  recipeID?: ModelIDInput | null,
  display?: ModelStringInput | null,
  ingredientID?: ModelIDInput | null,
  quantity?: ModelStringInput | null,
  unitOfMeasure?: ModelStringInput | null,
  pantryItem?: ModelBooleanInput | null,
  and?: Array< ModelRecipeIngredientsGroupFilterInput | null > | null,
  or?: Array< ModelRecipeIngredientsGroupFilterInput | null > | null,
  not?: ModelRecipeIngredientsGroupFilterInput | null,
};

export type ModelScheduledMessageFilterInput = {
  id?: ModelIDInput | null,
  dialogTrigger?: ModelStringInput | null,
  rrule?: ModelStringInput | null,
  periodOffset?: ModelIntInput | null,
  scheduledDate?: ModelStringInput | null,
  scheduledTime?: ModelStringInput | null,
  and?: Array< ModelScheduledMessageFilterInput | null > | null,
  or?: Array< ModelScheduledMessageFilterInput | null > | null,
  not?: ModelScheduledMessageFilterInput | null,
};

export type ModelScheduledMessageConnection = {
  __typename: "ModelScheduledMessageConnection",
  items:  Array<ScheduledMessage | null >,
  nextToken?: string | null,
};

export type ModelStickyNoteFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  content?: ModelStringInput | null,
  color?: ModelStringInput | null,
  ownerID?: ModelIDInput | null,
  sharedWithIDs?: ModelIDInput | null,
  and?: Array< ModelStickyNoteFilterInput | null > | null,
  or?: Array< ModelStickyNoteFilterInput | null > | null,
  not?: ModelStickyNoteFilterInput | null,
};

export type ModelStickyNoteConnection = {
  __typename: "ModelStickyNoteConnection",
  items:  Array<StickyNote | null >,
  nextToken?: string | null,
};

export type ModelSystemPropertyFilterInput = {
  name?: ModelStringInput | null,
  label?: ModelStringInput | null,
  description?: ModelStringInput | null,
  value?: ModelStringInput | null,
  read_groups?: ModelStringInput | null,
  public?: ModelBooleanInput | null,
  and?: Array< ModelSystemPropertyFilterInput | null > | null,
  or?: Array< ModelSystemPropertyFilterInput | null > | null,
  not?: ModelSystemPropertyFilterInput | null,
};

export type ModelSystemPropertyConnection = {
  __typename: "ModelSystemPropertyConnection",
  items:  Array<SystemProperty | null >,
  nextToken?: string | null,
};

export type ModelTaskListFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  emoji?: ModelStringInput | null,
  title?: ModelStringInput | null,
  type?: ModelTaskListTypeInput | null,
  primaryIngredientList?: ModelBooleanInput | null,
  top?: ModelBooleanInput | null,
  favourite?: ModelBooleanInput | null,
  isAkinList?: ModelBooleanInput | null,
  principalID?: ModelIDInput | null,
  participantIDS?: ModelStringInput | null,
  checklist?: ModelStringInput | null,
  image?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelTaskListFilterInput | null > | null,
  or?: Array< ModelTaskListFilterInput | null > | null,
  not?: ModelTaskListFilterInput | null,
};

export type ModelTaskListConnection = {
  __typename: "ModelTaskListConnection",
  items:  Array<TaskList | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  sub?: ModelIDInput | null,
  name?: ModelStringInput | null,
  location?: ModelStringInput | null,
  username?: ModelStringInput | null,
  primary?: ModelBooleanInput | null,
  habitatID?: ModelIDInput | null,
  role?: ModelUserRoleInput | null,
  email?: ModelStringInput | null,
  phoneNumber?: ModelStringInput | null,
  NDISAccountName?: ModelStringInput | null,
  NDISNumber?: ModelStringInput | null,
  birthday?: ModelStringInput | null,
  planManagerName?: ModelStringInput | null,
  planManagerEmail?: ModelStringInput | null,
  emailVerified?: ModelBooleanInput | null,
  carerPhone?: ModelStringInput | null,
  carerName?: ModelStringInput | null,
  supportWorkerPhone?: ModelStringInput | null,
  supportWorkerName?: ModelStringInput | null,
  contacts?: ModelIDInput | null,
  favouriteContacts?: ModelIDInput | null,
  profileColor?: ModelStringInput | null,
  profilePicture?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  customPictureURL?: ModelStringInput | null,
  endpointIds?: ModelStringInput | null,
  hasCompletedMealOnboarding?: ModelBooleanInput | null,
  hasViewedMealSection?: ModelBooleanInput | null,
  hasViewedGoalSection?: ModelBooleanInput | null,
  recipePreferenceOptionIDs?: ModelStringInput | null,
  onboardingToken?: ModelIDInput | null,
  hasOnboarded?: ModelBooleanInput | null,
  skippedOnboardingWizard?: ModelBooleanInput | null,
  onboardingRecipeChoices?: ModelStringInput | null,
  dashboardLayoutPreset?: ModelStringInput | null,
  chatApplicationId?: ModelStringInput | null,
  people?: ModelIntInput | null,
  budget?: ModelIntInput | null,
  time_and_effort?: ModelIntInput | null,
  dietary_balance?: ModelIntInput | null,
  allergies?: ModelStringInput | null,
  prepTime?: ModelIntInput | null,
  skillLevel?: ModelIntInput | null,
  is_child_profile?: ModelBooleanInput | null,
  favourite_recipe_ids?: ModelIDInput | null,
  contact_id?: ModelIDInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelContactFilterInput = {
  id?: ModelIDInput | null,
  habitatID?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelStringInput | null,
  tags?: ModelStringInput | null,
  emailAddresses?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  contactColor?: ModelStringInput | null,
  stockImage?: ModelStringInput | null,
  imageID?: ModelIDInput | null,
  publicImageURL?: ModelStringInput | null,
  user_id?: ModelIDInput | null,
  and?: Array< ModelContactFilterInput | null > | null,
  or?: Array< ModelContactFilterInput | null > | null,
  not?: ModelContactFilterInput | null,
};

export type ModelContactConnection = {
  __typename: "ModelContactConnection",
  items:  Array<Contact | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelLogEventByUserAndTypeCompositeKeyConditionInput = {
  eq?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
  le?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
  lt?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
  ge?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
  gt?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
  between?: Array< ModelLogEventByUserAndTypeCompositeKeyInput | null > | null,
  beginsWith?: ModelLogEventByUserAndTypeCompositeKeyInput | null,
};

export type ModelLogEventByUserAndTypeCompositeKeyInput = {
  type?: LogEventType | null,
  createdAt?: string | null,
};

export type SubmitAppRequestMutationVariables = {
  app_name?: string | null,
  username?: string | null,
};

export type SubmitAppRequestMutation = {
  submitAppRequest?: string | null,
};

export type SendNotificationMutationVariables = {
  msg?: string | null,
  habitatID?: string | null,
};

export type SendNotificationMutation = {
  sendNotification?:  {
    __typename: "NotificationResponse",
    msg?: string | null,
    habitatID?: string | null,
  } | null,
};

export type SignupAccountMutationVariables = {
  data?: string | null,
};

export type SignupAccountMutation = {
  signupAccount?: string | null,
};

export type UpdateAccountMutationVariables = {
  data?: string | null,
};

export type UpdateAccountMutation = {
  updateAccount?: string | null,
};

export type DeleteAccountMutationVariables = {
  data?: string | null,
};

export type DeleteAccountMutation = {
  deleteAccount?: string | null,
};

export type SendCalendarInvitationsMutationVariables = {
  data?: string | null,
};

export type SendCalendarInvitationsMutation = {
  sendCalendarInvitations?: string | null,
};

export type SetLockPINMutationVariables = {
  params?: string | null,
};

export type SetLockPINMutation = {
  setLockPIN?: string | null,
};

export type ForgotLockPINMutationVariables = {
  user_id?: string | null,
};

export type ForgotLockPINMutation = {
  forgotLockPIN?: string | null,
};

export type UpdateStateMutationVariables = {
  data?: string | null,
};

export type UpdateStateMutation = {
  updateState?: string | null,
};

export type CreateAlarmMutationVariables = {
  input: CreateAlarmInput,
  condition?: ModelAlarmConditionInput | null,
};

export type CreateAlarmMutation = {
  createAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAlarmMutationVariables = {
  input: UpdateAlarmInput,
  condition?: ModelAlarmConditionInput | null,
};

export type UpdateAlarmMutation = {
  updateAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAlarmMutationVariables = {
  input: DeleteAlarmInput,
  condition?: ModelAlarmConditionInput | null,
};

export type DeleteAlarmMutation = {
  deleteAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateAlertMutationVariables = {
  input: CreateAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type CreateAlertMutation = {
  createAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateAlertMutationVariables = {
  input: UpdateAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type UpdateAlertMutation = {
  updateAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteAlertMutationVariables = {
  input: DeleteAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type DeleteAlertMutation = {
  deleteAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateMealMutationVariables = {
  input: CreateMealInput,
  condition?: ModelMealConditionInput | null,
};

export type CreateMealMutation = {
  createMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateMealMutationVariables = {
  input: UpdateMealInput,
  condition?: ModelMealConditionInput | null,
};

export type UpdateMealMutation = {
  updateMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteMealMutationVariables = {
  input: DeleteMealInput,
  condition?: ModelMealConditionInput | null,
};

export type DeleteMealMutation = {
  deleteMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateMealRecipeMutationVariables = {
  input: CreateMealRecipeInput,
  condition?: ModelMealRecipeConditionInput | null,
};

export type CreateMealRecipeMutation = {
  createMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMealRecipeMutationVariables = {
  input: UpdateMealRecipeInput,
  condition?: ModelMealRecipeConditionInput | null,
};

export type UpdateMealRecipeMutation = {
  updateMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMealRecipeMutationVariables = {
  input: DeleteMealRecipeInput,
  condition?: ModelMealRecipeConditionInput | null,
};

export type DeleteMealRecipeMutation = {
  deleteMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDashboardMutationVariables = {
  input: CreateDashboardInput,
  condition?: ModelDashboardConditionInput | null,
};

export type CreateDashboardMutation = {
  createDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDashboardMutationVariables = {
  input: UpdateDashboardInput,
  condition?: ModelDashboardConditionInput | null,
};

export type UpdateDashboardMutation = {
  updateDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDashboardMutationVariables = {
  input: DeleteDashboardInput,
  condition?: ModelDashboardConditionInput | null,
};

export type DeleteDashboardMutation = {
  deleteDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDomainMutationVariables = {
  input: CreateDomainInput,
  condition?: ModelDomainConditionInput | null,
};

export type CreateDomainMutation = {
  createDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateDomainMutationVariables = {
  input: UpdateDomainInput,
  condition?: ModelDomainConditionInput | null,
};

export type UpdateDomainMutation = {
  updateDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteDomainMutationVariables = {
  input: DeleteDomainInput,
  condition?: ModelDomainConditionInput | null,
};

export type DeleteDomainMutation = {
  deleteDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateFileMutationVariables = {
  input: CreateFileInput,
  condition?: ModelFileConditionInput | null,
};

export type CreateFileMutation = {
  createFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateFileMutationVariables = {
  input: UpdateFileInput,
  condition?: ModelFileConditionInput | null,
};

export type UpdateFileMutation = {
  updateFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteFileMutationVariables = {
  input: DeleteFileInput,
  condition?: ModelFileConditionInput | null,
};

export type DeleteFileMutation = {
  deleteFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateGoalMutationVariables = {
  input: CreateGoalInput,
  condition?: ModelGoalConditionInput | null,
};

export type CreateGoalMutation = {
  createGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateGoalMutationVariables = {
  input: UpdateGoalInput,
  condition?: ModelGoalConditionInput | null,
};

export type UpdateGoalMutation = {
  updateGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteGoalMutationVariables = {
  input: DeleteGoalInput,
  condition?: ModelGoalConditionInput | null,
};

export type DeleteGoalMutation = {
  deleteGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateHabitatMutationVariables = {
  input: CreateHabitatInput,
  condition?: ModelHabitatConditionInput | null,
};

export type CreateHabitatMutation = {
  createHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateHabitatMutationVariables = {
  input: UpdateHabitatInput,
  condition?: ModelHabitatConditionInput | null,
};

export type UpdateHabitatMutation = {
  updateHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteHabitatMutationVariables = {
  input: DeleteHabitatInput,
  condition?: ModelHabitatConditionInput | null,
};

export type DeleteHabitatMutation = {
  deleteHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecipeFavouriteMutationVariables = {
  input: CreateRecipeFavouriteInput,
  condition?: ModelRecipeFavouriteConditionInput | null,
};

export type CreateRecipeFavouriteMutation = {
  createRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecipeFavouriteMutationVariables = {
  input: UpdateRecipeFavouriteInput,
  condition?: ModelRecipeFavouriteConditionInput | null,
};

export type UpdateRecipeFavouriteMutation = {
  updateRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecipeFavouriteMutationVariables = {
  input: DeleteRecipeFavouriteInput,
  condition?: ModelRecipeFavouriteConditionInput | null,
};

export type DeleteRecipeFavouriteMutation = {
  deleteRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateImageMutationVariables = {
  input: CreateImageInput,
  condition?: ModelImageConditionInput | null,
};

export type CreateImageMutation = {
  createImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateImageMutationVariables = {
  input: UpdateImageInput,
  condition?: ModelImageConditionInput | null,
};

export type UpdateImageMutation = {
  updateImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteImageMutationVariables = {
  input: DeleteImageInput,
  condition?: ModelImageConditionInput | null,
};

export type DeleteImageMutation = {
  deleteImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateIngredientGroupMutationVariables = {
  input: CreateIngredientGroupInput,
  condition?: ModelIngredientGroupConditionInput | null,
};

export type CreateIngredientGroupMutation = {
  createIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateIngredientGroupMutationVariables = {
  input: UpdateIngredientGroupInput,
  condition?: ModelIngredientGroupConditionInput | null,
};

export type UpdateIngredientGroupMutation = {
  updateIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteIngredientGroupMutationVariables = {
  input: DeleteIngredientGroupInput,
  condition?: ModelIngredientGroupConditionInput | null,
};

export type DeleteIngredientGroupMutation = {
  deleteIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateIngredientItemMutationVariables = {
  input: CreateIngredientItemInput,
  condition?: ModelIngredientItemConditionInput | null,
};

export type CreateIngredientItemMutation = {
  createIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateIngredientItemMutationVariables = {
  input: UpdateIngredientItemInput,
  condition?: ModelIngredientItemConditionInput | null,
};

export type UpdateIngredientItemMutation = {
  updateIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteIngredientItemMutationVariables = {
  input: DeleteIngredientItemInput,
  condition?: ModelIngredientItemConditionInput | null,
};

export type DeleteIngredientItemMutation = {
  deleteIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLockPinMutationVariables = {
  input: CreateLockPinInput,
  condition?: ModelLockPinConditionInput | null,
};

export type CreateLockPinMutation = {
  createLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateLockPinMutationVariables = {
  input: UpdateLockPinInput,
  condition?: ModelLockPinConditionInput | null,
};

export type UpdateLockPinMutation = {
  updateLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteLockPinMutationVariables = {
  input: DeleteLockPinInput,
  condition?: ModelLockPinConditionInput | null,
};

export type DeleteLockPinMutation = {
  deleteLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateLogEventMutationVariables = {
  input: CreateLogEventInput,
  condition?: ModelLogEventConditionInput | null,
};

export type CreateLogEventMutation = {
  createLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateLogEventMutationVariables = {
  input: UpdateLogEventInput,
  condition?: ModelLogEventConditionInput | null,
};

export type UpdateLogEventMutation = {
  updateLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteLogEventMutationVariables = {
  input: DeleteLogEventInput,
  condition?: ModelLogEventConditionInput | null,
};

export type DeleteLogEventMutation = {
  deleteLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateMealPlanMutationVariables = {
  input: CreateMealPlanInput,
  condition?: ModelMealPlanConditionInput | null,
};

export type CreateMealPlanMutation = {
  createMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMealPlanMutationVariables = {
  input: UpdateMealPlanInput,
  condition?: ModelMealPlanConditionInput | null,
};

export type UpdateMealPlanMutation = {
  updateMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMealPlanMutationVariables = {
  input: DeleteMealPlanInput,
  condition?: ModelMealPlanConditionInput | null,
};

export type DeleteMealPlanMutation = {
  deleteMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOptionMutationVariables = {
  input: CreateOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type CreateOptionMutation = {
  createOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateOptionMutationVariables = {
  input: UpdateOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type UpdateOptionMutation = {
  updateOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteOptionMutationVariables = {
  input: DeleteOptionInput,
  condition?: ModelOptionConditionInput | null,
};

export type DeleteOptionMutation = {
  deleteOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecordOptionMutationVariables = {
  input: CreateRecordOptionInput,
  condition?: ModelRecordOptionConditionInput | null,
};

export type CreateRecordOptionMutation = {
  createRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecordOptionMutationVariables = {
  input: UpdateRecordOptionInput,
  condition?: ModelRecordOptionConditionInput | null,
};

export type UpdateRecordOptionMutation = {
  updateRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecordOptionMutationVariables = {
  input: DeleteRecordOptionInput,
  condition?: ModelRecordOptionConditionInput | null,
};

export type DeleteRecordOptionMutation = {
  deleteRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProfileMutationVariables = {
  input: CreateProfileInput,
  condition?: ModelProfileConditionInput | null,
};

export type CreateProfileMutation = {
  createProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateProfileMutationVariables = {
  input: UpdateProfileInput,
  condition?: ModelProfileConditionInput | null,
};

export type UpdateProfileMutation = {
  updateProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteProfileMutationVariables = {
  input: DeleteProfileInput,
  condition?: ModelProfileConditionInput | null,
};

export type DeleteProfileMutation = {
  deleteProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateRecipeMutationVariables = {
  input: CreateRecipeInput,
  condition?: ModelRecipeConditionInput | null,
};

export type CreateRecipeMutation = {
  createRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecipeMutationVariables = {
  input: UpdateRecipeInput,
  condition?: ModelRecipeConditionInput | null,
};

export type UpdateRecipeMutation = {
  updateRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecipeMutationVariables = {
  input: DeleteRecipeInput,
  condition?: ModelRecipeConditionInput | null,
};

export type DeleteRecipeMutation = {
  deleteRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecipeIngredientsGroupMutationVariables = {
  input: CreateRecipeIngredientsGroupInput,
  condition?: ModelRecipeIngredientsGroupConditionInput | null,
};

export type CreateRecipeIngredientsGroupMutation = {
  createRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecipeIngredientsGroupMutationVariables = {
  input: UpdateRecipeIngredientsGroupInput,
  condition?: ModelRecipeIngredientsGroupConditionInput | null,
};

export type UpdateRecipeIngredientsGroupMutation = {
  updateRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecipeIngredientsGroupMutationVariables = {
  input: DeleteRecipeIngredientsGroupInput,
  condition?: ModelRecipeIngredientsGroupConditionInput | null,
};

export type DeleteRecipeIngredientsGroupMutation = {
  deleteRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateScheduledMessageMutationVariables = {
  input: CreateScheduledMessageInput,
  condition?: ModelScheduledMessageConditionInput | null,
};

export type CreateScheduledMessageMutation = {
  createScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateScheduledMessageMutationVariables = {
  input: UpdateScheduledMessageInput,
  condition?: ModelScheduledMessageConditionInput | null,
};

export type UpdateScheduledMessageMutation = {
  updateScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteScheduledMessageMutationVariables = {
  input: DeleteScheduledMessageInput,
  condition?: ModelScheduledMessageConditionInput | null,
};

export type DeleteScheduledMessageMutation = {
  deleteScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStickyNoteMutationVariables = {
  input: CreateStickyNoteInput,
  condition?: ModelStickyNoteConditionInput | null,
};

export type CreateStickyNoteMutation = {
  createStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStickyNoteMutationVariables = {
  input: UpdateStickyNoteInput,
  condition?: ModelStickyNoteConditionInput | null,
};

export type UpdateStickyNoteMutation = {
  updateStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStickyNoteMutationVariables = {
  input: DeleteStickyNoteInput,
  condition?: ModelStickyNoteConditionInput | null,
};

export type DeleteStickyNoteMutation = {
  deleteStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSystemPropertyMutationVariables = {
  input: CreateSystemPropertyInput,
  condition?: ModelSystemPropertyConditionInput | null,
};

export type CreateSystemPropertyMutation = {
  createSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSystemPropertyMutationVariables = {
  input: UpdateSystemPropertyInput,
  condition?: ModelSystemPropertyConditionInput | null,
};

export type UpdateSystemPropertyMutation = {
  updateSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSystemPropertyMutationVariables = {
  input: DeleteSystemPropertyInput,
  condition?: ModelSystemPropertyConditionInput | null,
};

export type DeleteSystemPropertyMutation = {
  deleteSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTaskListMutationVariables = {
  input: CreateTaskListInput,
  condition?: ModelTaskListConditionInput | null,
};

export type CreateTaskListMutation = {
  createTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTaskListMutationVariables = {
  input: UpdateTaskListInput,
  condition?: ModelTaskListConditionInput | null,
};

export type UpdateTaskListMutation = {
  updateTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTaskListMutationVariables = {
  input: DeleteTaskListInput,
  condition?: ModelTaskListConditionInput | null,
};

export type DeleteTaskListMutation = {
  deleteTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateContactMutationVariables = {
  input: CreateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type CreateContactMutation = {
  createContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateContactMutationVariables = {
  input: UpdateContactInput,
  condition?: ModelContactConditionInput | null,
};

export type UpdateContactMutation = {
  updateContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteContactMutationVariables = {
  input: DeleteContactInput,
  condition?: ModelContactConditionInput | null,
};

export type DeleteContactMutation = {
  deleteContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserScheduledMessageMutationVariables = {
  input: CreateUserScheduledMessageInput,
  condition?: ModelUserScheduledMessageConditionInput | null,
};

export type CreateUserScheduledMessageMutation = {
  createUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserScheduledMessageMutationVariables = {
  input: UpdateUserScheduledMessageInput,
  condition?: ModelUserScheduledMessageConditionInput | null,
};

export type UpdateUserScheduledMessageMutation = {
  updateUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserScheduledMessageMutationVariables = {
  input: DeleteUserScheduledMessageInput,
  condition?: ModelUserScheduledMessageConditionInput | null,
};

export type DeleteUserScheduledMessageMutation = {
  deleteUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetAppListQueryVariables = {
};

export type GetAppListQuery = {
  getAppList?: string | null,
};

export type ListParticipantsQueryVariables = {
  data?: string | null,
};

export type ListParticipantsQuery = {
  listParticipants?: string | null,
};

export type ListVideoContentQueryVariables = {
};

export type ListVideoContentQuery = {
  listVideoContent?: string | null,
};

export type ValidateLockPINQueryVariables = {
  params?: string | null,
};

export type ValidateLockPINQuery = {
  validateLockPIN?: string | null,
};

export type FetchProactiveMessagesQueryVariables = {
  username?: string | null,
  application_id?: number | null,
};

export type FetchProactiveMessagesQuery = {
  fetchProactiveMessages?: string | null,
};

export type GetWeatherQueryVariables = {
  latitude?: number | null,
  longitude?: number | null,
  location?: string | null,
  date?: string | null,
};

export type GetWeatherQuery = {
  getWeather?: string | null,
};

export type GetStateQueryVariables = {
  data?: string | null,
};

export type GetStateQuery = {
  getState?: string | null,
};

export type GetAlarmQueryVariables = {
  id: string,
};

export type GetAlarmQuery = {
  getAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAlarmsQueryVariables = {
  filter?: ModelAlarmFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlarmsQuery = {
  listAlarms?:  {
    __typename: "ModelAlarmConnection",
    items:  Array< {
      __typename: "Alarm",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      // Stored as its own field for querying
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      // who is it for
      participantIDS?: Array< string | null > | null,
      // what needs to happen
      checklist?: string | null,
      notes?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      color?: string | null,
      // how and when do you want to be reminded about this alarm
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAlertQueryVariables = {
  id: string,
};

export type GetAlertQuery = {
  getAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListAlertsQueryVariables = {
  filter?: ModelAlertFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlertsQuery = {
  listAlerts?:  {
    __typename: "ModelAlertConnection",
    items:  Array< {
      __typename: "Alert",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      // Alert
      type?: CalendarItemType | null,
      // The start time for the alert
      start: string,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      // IDS of user participating in the alert
      participantIDS?: Array< string | null > | null,
      // what needs to happen
      checklist?: string | null,
      // Notes on the alert
      notes?: string | null,
      // Image for the alert
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      // Set if this reminder is for a goal
      goalID?: string | null,
      goal?:  {
        __typename: "Goal",
        id: string,
        habitatID?: string | null,
        emoji?: string | null,
        title: string,
        type?: CalendarItemType | null,
        start: string,
        end?: string | null,
        allDay?: boolean | null,
        recurrence?:  {
          __typename: "RRule",
          // The identifier for types of recurrence rules in the app
          mode: string,
          // Daily, Weekly, Yearly etc
          freq: number,
          // Every X days, weeks, months etc
          interval?: number | null,
          // Days of the week that it applies
          byweekday?: Array< number | null > | null,
          // Date to end the recurrence rule
          until?: string | null,
          // Number of recurrences that should occur
          count?: number | null,
        } | null,
        recurrenceUntil?: string | null,
        recurrenceInstanceMap?: string | null,
        // List of recurrence ids that have been deleted
        recurrenceExcludeDates?: string | null,
        location?: string | null,
        // who is it for
        principal?:  {
          __typename: "User",
          // The ID of the user
          id: string,
          // The cognito user sub
          sub: string,
          // Name of the user
          name: string,
          // Location of the user
          location?: string | null,
          // The username of the user. This should come from the cognito user pool
          username: string,
          // Indicates that this user is the primary habitat user. This user cannot be deleted.
          primary?: boolean | null,
          // The Habitat the user belongs to. May not be set when account is still being set up
          habitatID?: string | null,
          role?: UserRole | null,
          // Email of the user
          email?: string | null,
          // The users phone number
          phoneNumber?: string | null,
          NDISAccountName?: string | null,
          NDISNumber?: string | null,
          birthday?: string | null,
          planManagerName?: string | null,
          planManagerEmail?: string | null,
          emailVerified?: boolean | null,
          carerPhone?: string | null,
          carerName?: string | null,
          supportWorkerPhone?: string | null,
          supportWorkerName?: string | null,
          contacts?: Array< string | null > | null,
          favouriteContacts?: Array< string | null > | null,
          address?:  {
            __typename: "Address",
            type?: string | null,
            street?: string | null,
            city?: string | null,
            state?: string | null,
            postcode?: string | null,
            country?: string | null,
          } | null,
          // Profile color to be displayed with the users image
          profileColor?: string | null,
          // Selected Profile Picture - Stock Images from akin
          profilePicture?: string | null,
          imageID?: string | null,
          // Custom image uploaded from the device
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Public Image URL
          customPictureURL?: string | null,
          // Preferences linked to device system settings
          systemPreferences?:  {
            __typename: "SystemPreferences",
            androidNotificationSoundID?: string | null,
            androidAlarmSoundID?: string | null,
          } | null,
          scheduledMessages?:  {
            __typename: "ModelUserScheduledMessageConnection",
            nextToken?: string | null,
          } | null,
          endpointIds?: Array< string | null > | null,
          // Flag for whether the user has completed the meal onboarding
          hasCompletedMealOnboarding?: boolean | null,
          // Flag for whether the user has viewed the meals section of the app
          hasViewedMealSection?: boolean | null,
          // Flag for whether the user has viewed the goal section of the app
          hasViewedGoalSection?: boolean | null,
          // IDs of recipe preference options
          recipePreferenceOptionIDs?: Array< string | null > | null,
          // Token used when sending a link to the onboarding process
          onboardingToken?: string | null,
          // Flag for whether the user has been onboarded
          hasOnboarded?: boolean | null,
          // Flag for if the user has skipped the onboarding wizard
          skippedOnboardingWizard?: boolean | null,
          // The user's recipe choices in onboarding. A list of recipe IDs
          onboardingRecipeChoices?: Array< string | null > | null,
          // Dashboard Layout Preset
          dashboardLayoutPreset?: string | null,
          chatApplicationId?: string | null,
          people?: number | null,
          budget?: number | null,
          time_and_effort?: number | null,
          dietary_balance?: number | null,
          allergies?: Array< string | null > | null,
          prepTime?: number | null,
          avoidances?:  Array< {
            __typename: "FoodAvoidance",
            category?: string | null,
            degree?: number | null,
          } | null > | null,
          skillLevel?: number | null,
          // Indicates that this is profile is for a child
          is_child_profile?: boolean | null,
          // If defined, this is passed to chat system to enable user to use generative AI as a fallback
          use_generative_ai?:  {
            __typename: "UseGenerativeAIOptions",
            name?: string | null,
            model?: string | null,
            max_tokens?: number | null,
            temperature?: number | null,
          } | null,
          // List of the users favourite recipe IDs
          favourite_recipe_ids?: Array< string | null > | null,
          // ID of the linked contact record
          contact_id?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        principalID?: string | null,
        participantIDS?: Array< string | null > | null,
        // what do you need to bring
        checklist?: string | null,
        todo?: string | null,
        notes?: string | null,
        complete?: string | null,
        // A map of recurrence ids to their completion state.
        recurrenceCompletionStates?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        imageURL?: string | null,
        completions?: string | null,
        completions_per_period?: number | null,
        period?: GoalPeriod | null,
        // Reference code can be used to easily query the goal from bot actions and other app events
        reference_code?: string | null,
        // Groups that can read this Goal
        readGroups?: Array< string | null > | null,
        // Indicates that the goal is a template
        isTemplate?: boolean | null,
        // IDs that link to the options for goal categories
        category_ids?: Array< string | null > | null,
        // A hex code color for the goal. Is also used on alerts linked to the goal
        color?: string | null,
        // Owner of the Goal
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      color?: string | null,
      // how and when do you want to be reminded about this alert
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEventQueryVariables = {
  id: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end: string,
      allDay?: boolean | null,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      // what tasks do you need to do
      todo?: string | null,
      notes?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      color?: string | null,
      tags?: string | null,
      // how and when do you want to be reminded about this event
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMealQueryVariables = {
  id: string,
};

export type GetMealQuery = {
  getMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListMealsQueryVariables = {
  filter?: ModelMealFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMealsQuery = {
  listMeals?:  {
    __typename: "ModelMealConnection",
    items:  Array< {
      __typename: "Meal",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      mealType: MealType,
      start: string,
      end: string,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      // who else is going?
      participantIDS?: Array< string | null > | null,
      // Ingredients for the meal
      ingredients?:  Array< {
        __typename: "Ingredient",
        id: string,
        title: string,
        checked: boolean,
        shoppingListID?: string | null,
      } | null > | null,
      // preparation notes or steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      notes?: string | null,
      // Uploaded Image
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      recipes?:  {
        __typename: "ModelMealRecipeConnection",
        items:  Array< {
          __typename: "MealRecipe",
          id: string,
          mealID: string,
          recipeID: string,
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // Whether the meal was eaten
      eaten?: boolean | null,
      recommended?: boolean | null,
      acceptedRecommended?: boolean | null,
      // Indicates that this meal has been skipped. No recipe should be assigned to it.
      skipped?: boolean | null,
      // The meal plan this meal belongs to
      meal_plan_id?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDashboardQueryVariables = {
  id: string,
};

export type GetDashboardQuery = {
  getDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDashboardsQueryVariables = {
  filter?: ModelDashboardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDashboardsQuery = {
  listDashboards?:  {
    __typename: "ModelDashboardConnection",
    items:  Array< {
      __typename: "Dashboard",
      id: string,
      // Name of the dashboard
      name?: string | null,
      // Description of the dashboard
      description?: string | null,
      device_type?: DashboardDeviceType | null,
      // The user ID this dashboard is for
      user_id?: string | null,
      // Accounts allowed to read this
      read_accounts?: Array< string | null > | null,
      // Groups allowed to read this
      read_groups?: Array< string | null > | null,
      // Groups allowed to edit the dashboard
      full_access_groups?: Array< string | null > | null,
      // Data for linking to the S3 file
      layout?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDomainQueryVariables = {
  id: string,
};

export type GetDomainQuery = {
  getDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListDomainsQueryVariables = {
  filter?: ModelDomainFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDomainsQuery = {
  listDomains?:  {
    __typename: "ModelDomainConnection",
    items:  Array< {
      __typename: "Domain",
      id: string,
      name: string,
      parentDomainID?: string | null,
      subDomains?:  {
        __typename: "ModelDomainConnection",
        items:  Array< {
          __typename: "Domain",
          id: string,
          name: string,
          parentDomainID?: string | null,
          subDomains?:  {
            __typename: "ModelDomainConnection",
            nextToken?: string | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetFileQueryVariables = {
  id: string,
};

export type GetFileQuery = {
  getFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListFilesQueryVariables = {
  filter?: ModelFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListFilesQuery = {
  listFiles?:  {
    __typename: "ModelFileConnection",
    items:  Array< {
      __typename: "File",
      id: string,
      name: string,
      description?: string | null,
      // The file type. e.g. pdf, doc
      file_type: string,
      read_accounts?: Array< string | null > | null,
      read_groups?: Array< string | null > | null,
      full_access_groups?: Array< string | null > | null,
      // Data for linking to the S3 file
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      // File is publicly viewable
      public?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetGoalQueryVariables = {
  id: string,
};

export type GetGoalQuery = {
  getGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListGoalsQueryVariables = {
  filter?: ModelGoalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGoalsQuery = {
  listGoals?:  {
    __typename: "ModelGoalConnection",
    items:  Array< {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHabitatQueryVariables = {
  id: string,
};

export type GetHabitatQuery = {
  getHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListHabitatsQueryVariables = {
  filter?: ModelHabitatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHabitatsQuery = {
  listHabitats?:  {
    __typename: "ModelHabitatConnection",
    items:  Array< {
      __typename: "Habitat",
      id: string,
      habitatID: string,
      name?: string | null,
      favouriteRecipes?:  {
        __typename: "ModelRecipeFavouriteConnection",
        items:  Array< {
          __typename: "RecipeFavourite",
          id: string,
          habitatID: string,
          recipeID: string,
          recipe:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // This is the current way we are identifying favourite recipes. Much easier to work with local caching
      favouriteRecipeIDs?: Array< string | null > | null,
      // Image displayed on dashboard
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      imageURL?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetImageQueryVariables = {
  id: string,
};

export type GetImageQuery = {
  getImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListImagesQueryVariables = {
  filter?: ModelImageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListImagesQuery = {
  listImages?:  {
    __typename: "ModelImageConnection",
    items:  Array< {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIngredientGroupQueryVariables = {
  id: string,
};

export type GetIngredientGroupQuery = {
  getIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListIngredientGroupsQueryVariables = {
  filter?: ModelIngredientGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIngredientGroupsQuery = {
  listIngredientGroups?:  {
    __typename: "ModelIngredientGroupConnection",
    items:  Array< {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIngredientItemQueryVariables = {
  id: string,
};

export type GetIngredientItemQuery = {
  getIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListIngredientItemsQueryVariables = {
  filter?: ModelIngredientItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIngredientItemsQuery = {
  listIngredientItems?:  {
    __typename: "ModelIngredientItemConnection",
    items:  Array< {
      __typename: "IngredientItem",
      id: string,
      name: string,
      groupID: string,
      group?:  {
        __typename: "IngredientGroup",
        id: string,
        name: string,
        createdAt: string,
        updatedAt: string,
      } | null,
      recipeGroupID?: string | null,
      recipeGroup?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLockPinQueryVariables = {
  user_id: string,
};

export type GetLockPinQuery = {
  getLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListLockPinsQueryVariables = {
  user_id?: string | null,
  filter?: ModelLockPinFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListLockPinsQuery = {
  listLockPins?:  {
    __typename: "ModelLockPinConnection",
    items:  Array< {
      __typename: "LockPin",
      user_id: string,
      pin?: string | null,
      prompt_new_pin?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLogEventQueryVariables = {
  id: string,
};

export type GetLogEventQuery = {
  getLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListLogEventsQueryVariables = {
  filter?: ModelLogEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLogEventsQuery = {
  listLogEvents?:  {
    __typename: "ModelLogEventConnection",
    items:  Array< {
      __typename: "LogEvent",
      id: string,
      // The type of log event
      type: LogEventType,
      // Application the log came from
      source: LogEventSource,
      // Plaform type the log even originated
      platform: LogEventPlatform,
      // ID of the user account
      user_id?: string | null,
      feature_domain?: FeatureDomain | null,
      // Data is unique to each log event type
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMealPlanQueryVariables = {
  id: string,
};

export type GetMealPlanQuery = {
  getMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMealPlansQueryVariables = {
  filter?: ModelMealPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMealPlansQuery = {
  listMealPlans?:  {
    __typename: "ModelMealPlanConnection",
    items:  Array< {
      __typename: "MealPlan",
      id: string,
      habitatID?: string | null,
      week?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetOptionQueryVariables = {
  id: string,
};

export type GetOptionQuery = {
  getOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListOptionsQueryVariables = {
  filter?: ModelOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListOptionsQuery = {
  listOptions?:  {
    __typename: "ModelOptionConnection",
    items:  Array< {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProfileQueryVariables = {
  id: string,
};

export type GetProfileQuery = {
  getProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListProfilesQueryVariables = {
  filter?: ModelProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProfilesQuery = {
  listProfiles?:  {
    __typename: "ModelProfileConnection",
    items:  Array< {
      __typename: "Profile",
      id: string,
      habitatID: string,
      // ID of User that owns this profile
      userID?: string | null,
      name?: string | null,
      email?: string | null,
      role?: ProfileRole | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // A selected stock image
      stockImage?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecipeQueryVariables = {
  id: string,
};

export type GetRecipeQuery = {
  getRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecipesQueryVariables = {
  filter?: ModelRecipeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecipesQuery = {
  listRecipes?:  {
    __typename: "ModelRecipeConnection",
    items:  Array< {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecipeIngredientsGroupQueryVariables = {
  id: string,
};

export type GetRecipeIngredientsGroupQuery = {
  getRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecipeIngredientsGroupsQueryVariables = {
  filter?: ModelRecipeIngredientsGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecipeIngredientsGroupsQuery = {
  listRecipeIngredientsGroups?:  {
    __typename: "ModelRecipeIngredientsGroupConnection",
    items:  Array< {
      __typename: "RecipeIngredientsGroup",
      id: string,
      recipeID: string,
      // Optional display string for this ingredient
      display?: string | null,
      // The linked recipe
      recipe?:  {
        __typename: "Recipe",
        id: string,
        // Habitat ID for a recipe. This means the recipe is linked to a specific household
        habitatID?: string | null,
        // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
        readGroups?: Array< string | null > | null,
        name: string,
        searchField?: string | null,
        emoji?: string | null,
        // A short description or introduction to the dish
        description?: string | null,
        imageUrl?: string | null,
        // Indicates the recipe is still in development
        inProgress?: boolean | null,
        imageID?: string | null,
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
        mealTypes?: Array< MealType | null > | null,
        dishTypeID?: string | null,
        // The type or category of the dish
        dishType?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        dishTypeIDs?: Array< string | null > | null,
        skillLevelID?: string | null,
        // The recommended skill level for the dish
        skillLevel?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        servingSizeID?: string | null,
        // How many servings this recipe provides
        servingSize?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cuisineTypeID?: string | null,
        // How many servings this recipe provides
        cuisineType?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        familyfriendlyTypeID?: string | null,
        // How many servings this recipe provides
        familyfriendlyType?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        textureTypeID?: string | null,
        // How many servings this recipe provides
        textureType?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        specialDietIDs?: Array< string | null > | null,
        specialDiets?:  {
          __typename: "ModelRecordOptionConnection",
          items:  Array< {
            __typename: "RecordOption",
            id: string,
            recordID: string,
            optionID: string,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        prepTimeID?: string | null,
        // Preparation time selection
        prepTime?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Preparation steps
        prepNotes?:  Array< {
          __typename: "PreparationNote",
          id: string,
          title?: string | null,
          icon?: string | null,
          description: string,
        } | null > | null,
        mainIngredientID?: string | null,
        // The primary ingredient of the dish
        mainIngredient?:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // The health rating from 0-5
        health?: number | null,
        // Budget Rating
        budget?: number | null,
        // Utensils needed for the recipe
        utensils?: Array< string | null > | null,
        // List of ingredients
        ingredients?:  Array< {
          __typename: "RecipeIngredient",
          id: string,
          name: string,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          category?: string | null,
          pantryItem?: boolean | null,
          ingredientID?: string | null,
        } | null > | null,
        recipeIngredients?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
        allergyIDs?: Array< string | null > | null,
        // The default number of servings this recipe is for
        default_servings?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      ingredientID?: string | null,
      ingredient?:  {
        __typename: "ModelIngredientItemConnection",
        items:  Array< {
          __typename: "IngredientItem",
          id: string,
          name: string,
          groupID: string,
          group?:  {
            __typename: "IngredientGroup",
            id: string,
            name: string,
            createdAt: string,
            updatedAt: string,
          } | null,
          recipeGroupID?: string | null,
          recipeGroup?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      pantryItem?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetScheduledMessageQueryVariables = {
  id: string,
};

export type GetScheduledMessageQuery = {
  getScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListScheduledMessagesQueryVariables = {
  filter?: ModelScheduledMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListScheduledMessagesQuery = {
  listScheduledMessages?:  {
    __typename: "ModelScheduledMessageConnection",
    items:  Array< {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStickyNoteQueryVariables = {
  id: string,
};

export type GetStickyNoteQuery = {
  getStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStickyNotesQueryVariables = {
  filter?: ModelStickyNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStickyNotesQuery = {
  listStickyNotes?:  {
    __typename: "ModelStickyNoteConnection",
    items:  Array< {
      __typename: "StickyNote",
      id: string,
      // Habitat the note belongs to
      habitatID?: string | null,
      // Content of the note
      content?: string | null,
      // Color of the note
      color?: string | null,
      // ID Person who created the note
      ownerID?: string | null,
      // Record of person who created the note
      owner?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // IDs of the users this note has been shared with
      sharedWithIDs?: Array< string | null > | null,
      // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
      acknowledgements?:  Array< {
        __typename: "StickyNoteAcknowledgement",
        user_id?: string | null,
        date?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSystemPropertyQueryVariables = {
  name: string,
};

export type GetSystemPropertyQuery = {
  getSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSystemPropertysQueryVariables = {
  name?: string | null,
  filter?: ModelSystemPropertyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListSystemPropertysQuery = {
  listSystemPropertys?:  {
    __typename: "ModelSystemPropertyConnection",
    items:  Array< {
      __typename: "SystemProperty",
      // Primary Key
      name: string,
      // Display Label of the Property
      label: string,
      // Description of the property
      description?: string | null,
      // Value of the property
      value?: string | null,
      // Groups allowed to read this
      read_groups?: Array< string | null > | null,
      // System property is publicly viewable
      public?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTaskListQueryVariables = {
  id: string,
};

export type GetTaskListQuery = {
  getTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTaskListsQueryVariables = {
  filter?: ModelTaskListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTaskListsQuery = {
  listTaskLists?:  {
    __typename: "ModelTaskListConnection",
    items:  Array< {
      __typename: "TaskList",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: TaskListType | null,
      // Indicates that this list is the primary ingredients list.
      // This is the list that will have ingredients added to it from recipes etc
      primaryIngredientList?: boolean | null,
      top?: boolean | null,
      favourite?: boolean | null,
      isAkinList?: boolean | null,
      // who is it for
      principal:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      principalID: string,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      image?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetContactQueryVariables = {
  id: string,
};

export type GetContactQuery = {
  getContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListContactsQueryVariables = {
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListContactsQuery = {
  listContacts?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      habitatID: string,
      name: string,
      // Don't use the type field anymore
      type?: string | null,
      tags?: Array< string | null > | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        number: string,
        type: string,
      } | null > | null,
      emailAddresses?: Array< string | null > | null,
      addresses?:  Array< {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null > | null,
      notes?: Array< string | null > | null,
      // Profile color to be displayed with the contact's image
      contactColor?: string | null,
      // Selected Contact Picture - Stock Images from akin
      stockImage?: string | null,
      imageID?: string | null,
      // Custom contact image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      publicImageURL?: string | null,
      // ID of the linked user record
      user_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AlarmByHabitatQueryVariables = {
  habitatID?: string | null,
  start?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAlarmFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AlarmByHabitatQuery = {
  alarmByHabitat?:  {
    __typename: "ModelAlarmConnection",
    items:  Array< {
      __typename: "Alarm",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      // Stored as its own field for querying
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      // who is it for
      participantIDS?: Array< string | null > | null,
      // what needs to happen
      checklist?: string | null,
      notes?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      color?: string | null,
      // how and when do you want to be reminded about this alarm
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AlertByHabitatQueryVariables = {
  habitatID?: string | null,
  start?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAlertFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AlertByHabitatQuery = {
  alertByHabitat?:  {
    __typename: "ModelAlertConnection",
    items:  Array< {
      __typename: "Alert",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      // Alert
      type?: CalendarItemType | null,
      // The start time for the alert
      start: string,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      // IDS of user participating in the alert
      participantIDS?: Array< string | null > | null,
      // what needs to happen
      checklist?: string | null,
      // Notes on the alert
      notes?: string | null,
      // Image for the alert
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      // Set if this reminder is for a goal
      goalID?: string | null,
      goal?:  {
        __typename: "Goal",
        id: string,
        habitatID?: string | null,
        emoji?: string | null,
        title: string,
        type?: CalendarItemType | null,
        start: string,
        end?: string | null,
        allDay?: boolean | null,
        recurrence?:  {
          __typename: "RRule",
          // The identifier for types of recurrence rules in the app
          mode: string,
          // Daily, Weekly, Yearly etc
          freq: number,
          // Every X days, weeks, months etc
          interval?: number | null,
          // Days of the week that it applies
          byweekday?: Array< number | null > | null,
          // Date to end the recurrence rule
          until?: string | null,
          // Number of recurrences that should occur
          count?: number | null,
        } | null,
        recurrenceUntil?: string | null,
        recurrenceInstanceMap?: string | null,
        // List of recurrence ids that have been deleted
        recurrenceExcludeDates?: string | null,
        location?: string | null,
        // who is it for
        principal?:  {
          __typename: "User",
          // The ID of the user
          id: string,
          // The cognito user sub
          sub: string,
          // Name of the user
          name: string,
          // Location of the user
          location?: string | null,
          // The username of the user. This should come from the cognito user pool
          username: string,
          // Indicates that this user is the primary habitat user. This user cannot be deleted.
          primary?: boolean | null,
          // The Habitat the user belongs to. May not be set when account is still being set up
          habitatID?: string | null,
          role?: UserRole | null,
          // Email of the user
          email?: string | null,
          // The users phone number
          phoneNumber?: string | null,
          NDISAccountName?: string | null,
          NDISNumber?: string | null,
          birthday?: string | null,
          planManagerName?: string | null,
          planManagerEmail?: string | null,
          emailVerified?: boolean | null,
          carerPhone?: string | null,
          carerName?: string | null,
          supportWorkerPhone?: string | null,
          supportWorkerName?: string | null,
          contacts?: Array< string | null > | null,
          favouriteContacts?: Array< string | null > | null,
          address?:  {
            __typename: "Address",
            type?: string | null,
            street?: string | null,
            city?: string | null,
            state?: string | null,
            postcode?: string | null,
            country?: string | null,
          } | null,
          // Profile color to be displayed with the users image
          profileColor?: string | null,
          // Selected Profile Picture - Stock Images from akin
          profilePicture?: string | null,
          imageID?: string | null,
          // Custom image uploaded from the device
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Public Image URL
          customPictureURL?: string | null,
          // Preferences linked to device system settings
          systemPreferences?:  {
            __typename: "SystemPreferences",
            androidNotificationSoundID?: string | null,
            androidAlarmSoundID?: string | null,
          } | null,
          scheduledMessages?:  {
            __typename: "ModelUserScheduledMessageConnection",
            nextToken?: string | null,
          } | null,
          endpointIds?: Array< string | null > | null,
          // Flag for whether the user has completed the meal onboarding
          hasCompletedMealOnboarding?: boolean | null,
          // Flag for whether the user has viewed the meals section of the app
          hasViewedMealSection?: boolean | null,
          // Flag for whether the user has viewed the goal section of the app
          hasViewedGoalSection?: boolean | null,
          // IDs of recipe preference options
          recipePreferenceOptionIDs?: Array< string | null > | null,
          // Token used when sending a link to the onboarding process
          onboardingToken?: string | null,
          // Flag for whether the user has been onboarded
          hasOnboarded?: boolean | null,
          // Flag for if the user has skipped the onboarding wizard
          skippedOnboardingWizard?: boolean | null,
          // The user's recipe choices in onboarding. A list of recipe IDs
          onboardingRecipeChoices?: Array< string | null > | null,
          // Dashboard Layout Preset
          dashboardLayoutPreset?: string | null,
          chatApplicationId?: string | null,
          people?: number | null,
          budget?: number | null,
          time_and_effort?: number | null,
          dietary_balance?: number | null,
          allergies?: Array< string | null > | null,
          prepTime?: number | null,
          avoidances?:  Array< {
            __typename: "FoodAvoidance",
            category?: string | null,
            degree?: number | null,
          } | null > | null,
          skillLevel?: number | null,
          // Indicates that this is profile is for a child
          is_child_profile?: boolean | null,
          // If defined, this is passed to chat system to enable user to use generative AI as a fallback
          use_generative_ai?:  {
            __typename: "UseGenerativeAIOptions",
            name?: string | null,
            model?: string | null,
            max_tokens?: number | null,
            temperature?: number | null,
          } | null,
          // List of the users favourite recipe IDs
          favourite_recipe_ids?: Array< string | null > | null,
          // ID of the linked contact record
          contact_id?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        principalID?: string | null,
        participantIDS?: Array< string | null > | null,
        // what do you need to bring
        checklist?: string | null,
        todo?: string | null,
        notes?: string | null,
        complete?: string | null,
        // A map of recurrence ids to their completion state.
        recurrenceCompletionStates?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        imageURL?: string | null,
        completions?: string | null,
        completions_per_period?: number | null,
        period?: GoalPeriod | null,
        // Reference code can be used to easily query the goal from bot actions and other app events
        reference_code?: string | null,
        // Groups that can read this Goal
        readGroups?: Array< string | null > | null,
        // Indicates that the goal is a template
        isTemplate?: boolean | null,
        // IDs that link to the options for goal categories
        category_ids?: Array< string | null > | null,
        // A hex code color for the goal. Is also used on alerts linked to the goal
        color?: string | null,
        // Owner of the Goal
        owner?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      color?: string | null,
      // how and when do you want to be reminded about this alert
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EventByHabitatQueryVariables = {
  habitatID?: string | null,
  start?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EventByHabitatQuery = {
  eventByHabitat?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end: string,
      allDay?: boolean | null,
      // Recurrence Rule Stored as a string
      recurrence_rule?: string | null,
      // Legacy Recurrence Rule Object
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      // what tasks do you need to do
      todo?: string | null,
      notes?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      color?: string | null,
      tags?: string | null,
      // how and when do you want to be reminded about this event
      reminders?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MealByHabitatQueryVariables = {
  habitatID?: string | null,
  start?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMealFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MealByHabitatQuery = {
  mealByHabitat?:  {
    __typename: "ModelMealConnection",
    items:  Array< {
      __typename: "Meal",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      mealType: MealType,
      start: string,
      end: string,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      // who else is going?
      participantIDS?: Array< string | null > | null,
      // Ingredients for the meal
      ingredients?:  Array< {
        __typename: "Ingredient",
        id: string,
        title: string,
        checked: boolean,
        shoppingListID?: string | null,
      } | null > | null,
      // preparation notes or steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      notes?: string | null,
      // Uploaded Image
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      recipes?:  {
        __typename: "ModelMealRecipeConnection",
        items:  Array< {
          __typename: "MealRecipe",
          id: string,
          mealID: string,
          recipeID: string,
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // Whether the meal was eaten
      eaten?: boolean | null,
      recommended?: boolean | null,
      acceptedRecommended?: boolean | null,
      // Indicates that this meal has been skipped. No recipe should be assigned to it.
      skipped?: boolean | null,
      // The meal plan this meal belongs to
      meal_plan_id?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DashboardByUserQueryVariables = {
  user_id?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDashboardFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DashboardByUserQuery = {
  dashboardByUser?:  {
    __typename: "ModelDashboardConnection",
    items:  Array< {
      __typename: "Dashboard",
      id: string,
      // Name of the dashboard
      name?: string | null,
      // Description of the dashboard
      description?: string | null,
      device_type?: DashboardDeviceType | null,
      // The user ID this dashboard is for
      user_id?: string | null,
      // Accounts allowed to read this
      read_accounts?: Array< string | null > | null,
      // Groups allowed to read this
      read_groups?: Array< string | null > | null,
      // Groups allowed to edit the dashboard
      full_access_groups?: Array< string | null > | null,
      // Data for linking to the S3 file
      layout?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GoalByOwnerQueryVariables = {
  owner?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelGoalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GoalByOwnerQuery = {
  goalByOwner?:  {
    __typename: "ModelGoalConnection",
    items:  Array< {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type HabitatByHabitatIDQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHabitatFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type HabitatByHabitatIDQuery = {
  habitatByHabitatID?:  {
    __typename: "ModelHabitatConnection",
    items:  Array< {
      __typename: "Habitat",
      id: string,
      habitatID: string,
      name?: string | null,
      favouriteRecipes?:  {
        __typename: "ModelRecipeFavouriteConnection",
        items:  Array< {
          __typename: "RecipeFavourite",
          id: string,
          habitatID: string,
          recipeID: string,
          recipe:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // This is the current way we are identifying favourite recipes. Much easier to work with local caching
      favouriteRecipeIDs?: Array< string | null > | null,
      // Image displayed on dashboard
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      imageURL?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LogEventByTypeQueryVariables = {
  type?: LogEventType | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LogEventByTypeQuery = {
  logEventByType?:  {
    __typename: "ModelLogEventConnection",
    items:  Array< {
      __typename: "LogEvent",
      id: string,
      // The type of log event
      type: LogEventType,
      // Application the log came from
      source: LogEventSource,
      // Plaform type the log even originated
      platform: LogEventPlatform,
      // ID of the user account
      user_id?: string | null,
      feature_domain?: FeatureDomain | null,
      // Data is unique to each log event type
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LogEventByUserQueryVariables = {
  user_id?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LogEventByUserQuery = {
  logEventByUser?:  {
    __typename: "ModelLogEventConnection",
    items:  Array< {
      __typename: "LogEvent",
      id: string,
      // The type of log event
      type: LogEventType,
      // Application the log came from
      source: LogEventSource,
      // Plaform type the log even originated
      platform: LogEventPlatform,
      // ID of the user account
      user_id?: string | null,
      feature_domain?: FeatureDomain | null,
      // Data is unique to each log event type
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LogEventByUserAndTypeQueryVariables = {
  user_id?: string | null,
  typeCreatedAt?: ModelLogEventByUserAndTypeCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLogEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LogEventByUserAndTypeQuery = {
  logEventByUserAndType?:  {
    __typename: "ModelLogEventConnection",
    items:  Array< {
      __typename: "LogEvent",
      id: string,
      // The type of log event
      type: LogEventType,
      // Application the log came from
      source: LogEventSource,
      // Plaform type the log even originated
      platform: LogEventPlatform,
      // ID of the user account
      user_id?: string | null,
      feature_domain?: FeatureDomain | null,
      // Data is unique to each log event type
      data?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MealPlanByHabitatIDQueryVariables = {
  habitatID?: string | null,
  week?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMealPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MealPlanByHabitatIDQuery = {
  mealPlanByHabitatID?:  {
    __typename: "ModelMealPlanConnection",
    items:  Array< {
      __typename: "MealPlan",
      id: string,
      habitatID?: string | null,
      week?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OptionByTypeQueryVariables = {
  type?: string | null,
  label?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type OptionByTypeQuery = {
  optionByType?:  {
    __typename: "ModelOptionConnection",
    items:  Array< {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProfilesByHabitatQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProfilesByHabitatQuery = {
  profilesByHabitat?:  {
    __typename: "ModelProfileConnection",
    items:  Array< {
      __typename: "Profile",
      id: string,
      habitatID: string,
      // ID of User that owns this profile
      userID?: string | null,
      name?: string | null,
      email?: string | null,
      role?: ProfileRole | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // A selected stock image
      stockImage?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type StickyNoteByHabitatQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStickyNoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type StickyNoteByHabitatQuery = {
  stickyNoteByHabitat?:  {
    __typename: "ModelStickyNoteConnection",
    items:  Array< {
      __typename: "StickyNote",
      id: string,
      // Habitat the note belongs to
      habitatID?: string | null,
      // Content of the note
      content?: string | null,
      // Color of the note
      color?: string | null,
      // ID Person who created the note
      ownerID?: string | null,
      // Record of person who created the note
      owner?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // IDs of the users this note has been shared with
      sharedWithIDs?: Array< string | null > | null,
      // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
      acknowledgements?:  Array< {
        __typename: "StickyNoteAcknowledgement",
        user_id?: string | null,
        date?: string | null,
      } | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TasklistByOwnerQueryVariables = {
  owner?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TasklistByOwnerQuery = {
  tasklistByOwner?:  {
    __typename: "ModelTaskListConnection",
    items:  Array< {
      __typename: "TaskList",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: TaskListType | null,
      // Indicates that this list is the primary ingredients list.
      // This is the list that will have ingredients added to it from recipes etc
      primaryIngredientList?: boolean | null,
      top?: boolean | null,
      favourite?: boolean | null,
      isAkinList?: boolean | null,
      // who is it for
      principal:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      principalID: string,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      image?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type TasklistByHabitatQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelTaskListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type TasklistByHabitatQuery = {
  tasklistByHabitat?:  {
    __typename: "ModelTaskListConnection",
    items:  Array< {
      __typename: "TaskList",
      id: string,
      habitatID: string,
      emoji?: string | null,
      title: string,
      type?: TaskListType | null,
      // Indicates that this list is the primary ingredients list.
      // This is the list that will have ingredients added to it from recipes etc
      primaryIngredientList?: boolean | null,
      top?: boolean | null,
      favourite?: boolean | null,
      isAkinList?: boolean | null,
      // who is it for
      principal:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      principalID: string,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      image?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserBySubQueryVariables = {
  sub?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserBySubQuery = {
  userBySub?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByUsernameQueryVariables = {
  username?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByUsernameQuery = {
  userByUsername?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByHabitatQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByHabitatQuery = {
  userByHabitat?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ContactsByHabitatQueryVariables = {
  habitatID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelContactFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ContactsByHabitatQuery = {
  contactsByHabitat?:  {
    __typename: "ModelContactConnection",
    items:  Array< {
      __typename: "Contact",
      id: string,
      habitatID: string,
      name: string,
      // Don't use the type field anymore
      type?: string | null,
      tags?: Array< string | null > | null,
      phoneNumbers?:  Array< {
        __typename: "PhoneNumber",
        number: string,
        type: string,
      } | null > | null,
      emailAddresses?: Array< string | null > | null,
      addresses?:  Array< {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null > | null,
      notes?: Array< string | null > | null,
      // Profile color to be displayed with the contact's image
      contactColor?: string | null,
      // Selected Contact Picture - Stock Images from akin
      stockImage?: string | null,
      imageID?: string | null,
      // Custom contact image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      publicImageURL?: string | null,
      // ID of the linked user record
      user_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnGoalByHabitatIDSubscriptionVariables = {
  habitatID: string,
};

export type OnGoalByHabitatIDSubscription = {
  onGoalByHabitatID?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnSendNotificationSubscriptionVariables = {
  habitatID: string,
};

export type OnSendNotificationSubscription = {
  onSendNotification?:  {
    __typename: "NotificationResponse",
    msg?: string | null,
    habitatID?: string | null,
  } | null,
};

export type OnCreateAlarmSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateAlarmSubscription = {
  onCreateAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAlarmSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateAlarmSubscription = {
  onUpdateAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAlarmSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteAlarmSubscription = {
  onDeleteAlarm?:  {
    __typename: "Alarm",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    // Stored as its own field for querying
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // who is it for
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    // how and when do you want to be reminded about this alarm
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateAlertSubscription = {
  onCreateAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateAlertSubscription = {
  onUpdateAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteAlertSubscription = {
  onDeleteAlert?:  {
    __typename: "Alert",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    // Alert
    type?: CalendarItemType | null,
    // The start time for the alert
    start: string,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    // IDS of user participating in the alert
    participantIDS?: Array< string | null > | null,
    // what needs to happen
    checklist?: string | null,
    // Notes on the alert
    notes?: string | null,
    // Image for the alert
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    // Set if this reminder is for a goal
    goalID?: string | null,
    goal?:  {
      __typename: "Goal",
      id: string,
      habitatID?: string | null,
      emoji?: string | null,
      title: string,
      type?: CalendarItemType | null,
      start: string,
      end?: string | null,
      allDay?: boolean | null,
      recurrence?:  {
        __typename: "RRule",
        // The identifier for types of recurrence rules in the app
        mode: string,
        // Daily, Weekly, Yearly etc
        freq: number,
        // Every X days, weeks, months etc
        interval?: number | null,
        // Days of the week that it applies
        byweekday?: Array< number | null > | null,
        // Date to end the recurrence rule
        until?: string | null,
        // Number of recurrences that should occur
        count?: number | null,
      } | null,
      recurrenceUntil?: string | null,
      recurrenceInstanceMap?: string | null,
      // List of recurrence ids that have been deleted
      recurrenceExcludeDates?: string | null,
      location?: string | null,
      // who is it for
      principal?:  {
        __typename: "User",
        // The ID of the user
        id: string,
        // The cognito user sub
        sub: string,
        // Name of the user
        name: string,
        // Location of the user
        location?: string | null,
        // The username of the user. This should come from the cognito user pool
        username: string,
        // Indicates that this user is the primary habitat user. This user cannot be deleted.
        primary?: boolean | null,
        // The Habitat the user belongs to. May not be set when account is still being set up
        habitatID?: string | null,
        role?: UserRole | null,
        // Email of the user
        email?: string | null,
        // The users phone number
        phoneNumber?: string | null,
        NDISAccountName?: string | null,
        NDISNumber?: string | null,
        birthday?: string | null,
        planManagerName?: string | null,
        planManagerEmail?: string | null,
        emailVerified?: boolean | null,
        carerPhone?: string | null,
        carerName?: string | null,
        supportWorkerPhone?: string | null,
        supportWorkerName?: string | null,
        contacts?: Array< string | null > | null,
        favouriteContacts?: Array< string | null > | null,
        address?:  {
          __typename: "Address",
          type?: string | null,
          street?: string | null,
          city?: string | null,
          state?: string | null,
          postcode?: string | null,
          country?: string | null,
        } | null,
        // Profile color to be displayed with the users image
        profileColor?: string | null,
        // Selected Profile Picture - Stock Images from akin
        profilePicture?: string | null,
        imageID?: string | null,
        // Custom image uploaded from the device
        image?:  {
          __typename: "Image",
          id: string,
          name: string,
          habitatID?: string | null,
          readGroups?: Array< string | null > | null,
          // Data for linking to the S3 image
          data:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        // Public Image URL
        customPictureURL?: string | null,
        // Preferences linked to device system settings
        systemPreferences?:  {
          __typename: "SystemPreferences",
          androidNotificationSoundID?: string | null,
          androidAlarmSoundID?: string | null,
        } | null,
        scheduledMessages?:  {
          __typename: "ModelUserScheduledMessageConnection",
          items:  Array< {
            __typename: "UserScheduledMessage",
            id: string,
            userID: string,
            habitatID: string,
            scheduledMessageID: string,
            scheduledDate?: string | null,
            scheduledTime: string,
            answered?: boolean | null,
            delayCount?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        endpointIds?: Array< string | null > | null,
        // Flag for whether the user has completed the meal onboarding
        hasCompletedMealOnboarding?: boolean | null,
        // Flag for whether the user has viewed the meals section of the app
        hasViewedMealSection?: boolean | null,
        // Flag for whether the user has viewed the goal section of the app
        hasViewedGoalSection?: boolean | null,
        // IDs of recipe preference options
        recipePreferenceOptionIDs?: Array< string | null > | null,
        // Token used when sending a link to the onboarding process
        onboardingToken?: string | null,
        // Flag for whether the user has been onboarded
        hasOnboarded?: boolean | null,
        // Flag for if the user has skipped the onboarding wizard
        skippedOnboardingWizard?: boolean | null,
        // The user's recipe choices in onboarding. A list of recipe IDs
        onboardingRecipeChoices?: Array< string | null > | null,
        // Dashboard Layout Preset
        dashboardLayoutPreset?: string | null,
        chatApplicationId?: string | null,
        people?: number | null,
        budget?: number | null,
        time_and_effort?: number | null,
        dietary_balance?: number | null,
        allergies?: Array< string | null > | null,
        prepTime?: number | null,
        avoidances?:  Array< {
          __typename: "FoodAvoidance",
          category?: string | null,
          degree?: number | null,
        } | null > | null,
        skillLevel?: number | null,
        // Indicates that this is profile is for a child
        is_child_profile?: boolean | null,
        // If defined, this is passed to chat system to enable user to use generative AI as a fallback
        use_generative_ai?:  {
          __typename: "UseGenerativeAIOptions",
          name?: string | null,
          model?: string | null,
          max_tokens?: number | null,
          temperature?: number | null,
        } | null,
        // List of the users favourite recipe IDs
        favourite_recipe_ids?: Array< string | null > | null,
        // ID of the linked contact record
        contact_id?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      principalID?: string | null,
      participantIDS?: Array< string | null > | null,
      // what do you need to bring
      checklist?: string | null,
      todo?: string | null,
      notes?: string | null,
      complete?: string | null,
      // A map of recurrence ids to their completion state.
      recurrenceCompletionStates?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      imageURL?: string | null,
      completions?: string | null,
      completions_per_period?: number | null,
      period?: GoalPeriod | null,
      // Reference code can be used to easily query the goal from bot actions and other app events
      reference_code?: string | null,
      // Groups that can read this Goal
      readGroups?: Array< string | null > | null,
      // Indicates that the goal is a template
      isTemplate?: boolean | null,
      // IDs that link to the options for goal categories
      category_ids?: Array< string | null > | null,
      // A hex code color for the goal. Is also used on alerts linked to the goal
      color?: string | null,
      // Owner of the Goal
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    color?: string | null,
    // how and when do you want to be reminded about this alert
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end: string,
    allDay?: boolean | null,
    // Recurrence Rule Stored as a string
    recurrence_rule?: string | null,
    // Legacy Recurrence Rule Object
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    // what tasks do you need to do
    todo?: string | null,
    notes?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    color?: string | null,
    tags?: string | null,
    // how and when do you want to be reminded about this event
    reminders?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateMealSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateMealSubscription = {
  onCreateMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateMealSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateMealSubscription = {
  onUpdateMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteMealSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteMealSubscription = {
  onDeleteMeal?:  {
    __typename: "Meal",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    mealType: MealType,
    start: string,
    end: string,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    // who else is going?
    participantIDS?: Array< string | null > | null,
    // Ingredients for the meal
    ingredients?:  Array< {
      __typename: "Ingredient",
      id: string,
      title: string,
      checked: boolean,
      shoppingListID?: string | null,
    } | null > | null,
    // preparation notes or steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    notes?: string | null,
    // Uploaded Image
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    recipes?:  {
      __typename: "ModelMealRecipeConnection",
      items:  Array< {
        __typename: "MealRecipe",
        id: string,
        mealID: string,
        recipeID: string,
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // Whether the meal was eaten
    eaten?: boolean | null,
    recommended?: boolean | null,
    acceptedRecommended?: boolean | null,
    // Indicates that this meal has been skipped. No recipe should be assigned to it.
    skipped?: boolean | null,
    // The meal plan this meal belongs to
    meal_plan_id?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateMealRecipeSubscriptionVariables = {
};

export type OnCreateMealRecipeSubscription = {
  onCreateMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMealRecipeSubscriptionVariables = {
};

export type OnUpdateMealRecipeSubscription = {
  onUpdateMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMealRecipeSubscriptionVariables = {
};

export type OnDeleteMealRecipeSubscription = {
  onDeleteMealRecipe?:  {
    __typename: "MealRecipe",
    id: string,
    mealID: string,
    recipeID: string,
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDashboardSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnCreateDashboardSubscription = {
  onCreateDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDashboardSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnUpdateDashboardSubscription = {
  onUpdateDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDashboardSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnDeleteDashboardSubscription = {
  onDeleteDashboard?:  {
    __typename: "Dashboard",
    id: string,
    // Name of the dashboard
    name?: string | null,
    // Description of the dashboard
    description?: string | null,
    device_type?: DashboardDeviceType | null,
    // The user ID this dashboard is for
    user_id?: string | null,
    // Accounts allowed to read this
    read_accounts?: Array< string | null > | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // Groups allowed to edit the dashboard
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    layout?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDomainSubscriptionVariables = {
  owner: string,
};

export type OnCreateDomainSubscription = {
  onCreateDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateDomainSubscriptionVariables = {
  owner: string,
};

export type OnUpdateDomainSubscription = {
  onUpdateDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteDomainSubscriptionVariables = {
  owner: string,
};

export type OnDeleteDomainSubscription = {
  onDeleteDomain?:  {
    __typename: "Domain",
    id: string,
    name: string,
    parentDomainID?: string | null,
    subDomains?:  {
      __typename: "ModelDomainConnection",
      items:  Array< {
        __typename: "Domain",
        id: string,
        name: string,
        parentDomainID?: string | null,
        subDomains?:  {
          __typename: "ModelDomainConnection",
          items:  Array< {
            __typename: "Domain",
            id: string,
            name: string,
            parentDomainID?: string | null,
            createdAt: string,
            updatedAt: string,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateFileSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnCreateFileSubscription = {
  onCreateFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateFileSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnUpdateFileSubscription = {
  onUpdateFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteFileSubscriptionVariables = {
  owner?: string | null,
  read_accounts?: string | null,
};

export type OnDeleteFileSubscription = {
  onDeleteFile?:  {
    __typename: "File",
    id: string,
    name: string,
    description?: string | null,
    // The file type. e.g. pdf, doc
    file_type: string,
    read_accounts?: Array< string | null > | null,
    read_groups?: Array< string | null > | null,
    full_access_groups?: Array< string | null > | null,
    // Data for linking to the S3 file
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    // File is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateGoalSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateGoalSubscription = {
  onCreateGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateGoalSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateGoalSubscription = {
  onUpdateGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteGoalSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteGoalSubscription = {
  onDeleteGoal?:  {
    __typename: "Goal",
    id: string,
    habitatID?: string | null,
    emoji?: string | null,
    title: string,
    type?: CalendarItemType | null,
    start: string,
    end?: string | null,
    allDay?: boolean | null,
    recurrence?:  {
      __typename: "RRule",
      // The identifier for types of recurrence rules in the app
      mode: string,
      // Daily, Weekly, Yearly etc
      freq: number,
      // Every X days, weeks, months etc
      interval?: number | null,
      // Days of the week that it applies
      byweekday?: Array< number | null > | null,
      // Date to end the recurrence rule
      until?: string | null,
      // Number of recurrences that should occur
      count?: number | null,
    } | null,
    recurrenceUntil?: string | null,
    recurrenceInstanceMap?: string | null,
    // List of recurrence ids that have been deleted
    recurrenceExcludeDates?: string | null,
    location?: string | null,
    // who is it for
    principal?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    principalID?: string | null,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    todo?: string | null,
    notes?: string | null,
    complete?: string | null,
    // A map of recurrence ids to their completion state.
    recurrenceCompletionStates?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    imageURL?: string | null,
    completions?: string | null,
    completions_per_period?: number | null,
    period?: GoalPeriod | null,
    // Reference code can be used to easily query the goal from bot actions and other app events
    reference_code?: string | null,
    // Groups that can read this Goal
    readGroups?: Array< string | null > | null,
    // Indicates that the goal is a template
    isTemplate?: boolean | null,
    // IDs that link to the options for goal categories
    category_ids?: Array< string | null > | null,
    // A hex code color for the goal. Is also used on alerts linked to the goal
    color?: string | null,
    // Owner of the Goal
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateHabitatSubscriptionVariables = {
};

export type OnCreateHabitatSubscription = {
  onCreateHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateHabitatSubscriptionVariables = {
};

export type OnUpdateHabitatSubscription = {
  onUpdateHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteHabitatSubscriptionVariables = {
};

export type OnDeleteHabitatSubscription = {
  onDeleteHabitat?:  {
    __typename: "Habitat",
    id: string,
    habitatID: string,
    name?: string | null,
    favouriteRecipes?:  {
      __typename: "ModelRecipeFavouriteConnection",
      items:  Array< {
        __typename: "RecipeFavourite",
        id: string,
        habitatID: string,
        recipeID: string,
        recipe:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // This is the current way we are identifying favourite recipes. Much easier to work with local caching
    favouriteRecipeIDs?: Array< string | null > | null,
    // Image displayed on dashboard
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    imageURL?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRecipeFavouriteSubscriptionVariables = {
};

export type OnCreateRecipeFavouriteSubscription = {
  onCreateRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecipeFavouriteSubscriptionVariables = {
};

export type OnUpdateRecipeFavouriteSubscription = {
  onUpdateRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecipeFavouriteSubscriptionVariables = {
};

export type OnDeleteRecipeFavouriteSubscription = {
  onDeleteRecipeFavourite?:  {
    __typename: "RecipeFavourite",
    id: string,
    habitatID: string,
    recipeID: string,
    recipe:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateImageSubscriptionVariables = {
};

export type OnCreateImageSubscription = {
  onCreateImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateImageSubscriptionVariables = {
};

export type OnUpdateImageSubscription = {
  onUpdateImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteImageSubscriptionVariables = {
};

export type OnDeleteImageSubscription = {
  onDeleteImage?:  {
    __typename: "Image",
    id: string,
    name: string,
    habitatID?: string | null,
    readGroups?: Array< string | null > | null,
    // Data for linking to the S3 image
    data:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    },
    thumbnail?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateIngredientGroupSubscriptionVariables = {
};

export type OnCreateIngredientGroupSubscription = {
  onCreateIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateIngredientGroupSubscriptionVariables = {
};

export type OnUpdateIngredientGroupSubscription = {
  onUpdateIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteIngredientGroupSubscriptionVariables = {
};

export type OnDeleteIngredientGroupSubscription = {
  onDeleteIngredientGroup?:  {
    __typename: "IngredientGroup",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateIngredientItemSubscriptionVariables = {
};

export type OnCreateIngredientItemSubscription = {
  onCreateIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateIngredientItemSubscriptionVariables = {
};

export type OnUpdateIngredientItemSubscription = {
  onUpdateIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteIngredientItemSubscriptionVariables = {
};

export type OnDeleteIngredientItemSubscription = {
  onDeleteIngredientItem?:  {
    __typename: "IngredientItem",
    id: string,
    name: string,
    groupID: string,
    group?:  {
      __typename: "IngredientGroup",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
    } | null,
    recipeGroupID?: string | null,
    recipeGroup?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLockPinSubscriptionVariables = {
  owner: string,
};

export type OnCreateLockPinSubscription = {
  onCreateLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateLockPinSubscriptionVariables = {
  owner: string,
};

export type OnUpdateLockPinSubscription = {
  onUpdateLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteLockPinSubscriptionVariables = {
  owner: string,
};

export type OnDeleteLockPinSubscription = {
  onDeleteLockPin?:  {
    __typename: "LockPin",
    user_id: string,
    pin?: string | null,
    prompt_new_pin?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateLogEventSubscriptionVariables = {
};

export type OnCreateLogEventSubscription = {
  onCreateLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateLogEventSubscriptionVariables = {
};

export type OnUpdateLogEventSubscription = {
  onUpdateLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteLogEventSubscriptionVariables = {
};

export type OnDeleteLogEventSubscription = {
  onDeleteLogEvent?:  {
    __typename: "LogEvent",
    id: string,
    // The type of log event
    type: LogEventType,
    // Application the log came from
    source: LogEventSource,
    // Plaform type the log even originated
    platform: LogEventPlatform,
    // ID of the user account
    user_id?: string | null,
    feature_domain?: FeatureDomain | null,
    // Data is unique to each log event type
    data?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateMealPlanSubscriptionVariables = {
};

export type OnCreateMealPlanSubscription = {
  onCreateMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMealPlanSubscriptionVariables = {
};

export type OnUpdateMealPlanSubscription = {
  onUpdateMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMealPlanSubscriptionVariables = {
};

export type OnDeleteMealPlanSubscription = {
  onDeleteMealPlan?:  {
    __typename: "MealPlan",
    id: string,
    habitatID?: string | null,
    week?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateOptionSubscriptionVariables = {
};

export type OnCreateOptionSubscription = {
  onCreateOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateOptionSubscriptionVariables = {
};

export type OnUpdateOptionSubscription = {
  onUpdateOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteOptionSubscriptionVariables = {
};

export type OnDeleteOptionSubscription = {
  onDeleteOption?:  {
    __typename: "Option",
    id: string,
    // This type of option. This can be used to determine which dropdowns or lists the option can be used in
    type: string,
    // The displayed text for this option
    label: string,
    // Unique string code makes the option easier to reference and identify
    code: string,
    // Icons that may be displayed alongside the option
    icon?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRecordOptionSubscriptionVariables = {
};

export type OnCreateRecordOptionSubscription = {
  onCreateRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecordOptionSubscriptionVariables = {
};

export type OnUpdateRecordOptionSubscription = {
  onUpdateRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecordOptionSubscriptionVariables = {
};

export type OnDeleteRecordOptionSubscription = {
  onDeleteRecordOption?:  {
    __typename: "RecordOption",
    id: string,
    recordID: string,
    optionID: string,
    option:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProfileSubscriptionVariables = {
  owner: string,
};

export type OnCreateProfileSubscription = {
  onCreateProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateProfileSubscriptionVariables = {
  owner: string,
};

export type OnUpdateProfileSubscription = {
  onUpdateProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteProfileSubscriptionVariables = {
  owner: string,
};

export type OnDeleteProfileSubscription = {
  onDeleteProfile?:  {
    __typename: "Profile",
    id: string,
    habitatID: string,
    // ID of User that owns this profile
    userID?: string | null,
    name?: string | null,
    email?: string | null,
    role?: ProfileRole | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // A selected stock image
    stockImage?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateRecipeSubscriptionVariables = {
};

export type OnCreateRecipeSubscription = {
  onCreateRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecipeSubscriptionVariables = {
};

export type OnUpdateRecipeSubscription = {
  onUpdateRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecipeSubscriptionVariables = {
};

export type OnDeleteRecipeSubscription = {
  onDeleteRecipe?:  {
    __typename: "Recipe",
    id: string,
    // Habitat ID for a recipe. This means the recipe is linked to a specific household
    habitatID?: string | null,
    // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
    readGroups?: Array< string | null > | null,
    name: string,
    searchField?: string | null,
    emoji?: string | null,
    // A short description or introduction to the dish
    description?: string | null,
    imageUrl?: string | null,
    // Indicates the recipe is still in development
    inProgress?: boolean | null,
    imageID?: string | null,
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
    mealTypes?: Array< MealType | null > | null,
    dishTypeID?: string | null,
    // The type or category of the dish
    dishType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    dishTypeIDs?: Array< string | null > | null,
    skillLevelID?: string | null,
    // The recommended skill level for the dish
    skillLevel?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    servingSizeID?: string | null,
    // How many servings this recipe provides
    servingSize?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cuisineTypeID?: string | null,
    // How many servings this recipe provides
    cuisineType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    familyfriendlyTypeID?: string | null,
    // How many servings this recipe provides
    familyfriendlyType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    textureTypeID?: string | null,
    // How many servings this recipe provides
    textureType?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    specialDietIDs?: Array< string | null > | null,
    specialDiets?:  {
      __typename: "ModelRecordOptionConnection",
      items:  Array< {
        __typename: "RecordOption",
        id: string,
        recordID: string,
        optionID: string,
        option:  {
          __typename: "Option",
          id: string,
          // This type of option. This can be used to determine which dropdowns or lists the option can be used in
          type: string,
          // The displayed text for this option
          label: string,
          // Unique string code makes the option easier to reference and identify
          code: string,
          // Icons that may be displayed alongside the option
          icon?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    prepTimeID?: string | null,
    // Preparation time selection
    prepTime?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Preparation steps
    prepNotes?:  Array< {
      __typename: "PreparationNote",
      id: string,
      title?: string | null,
      icon?: string | null,
      description: string,
    } | null > | null,
    mainIngredientID?: string | null,
    // The primary ingredient of the dish
    mainIngredient?:  {
      __typename: "Option",
      id: string,
      // This type of option. This can be used to determine which dropdowns or lists the option can be used in
      type: string,
      // The displayed text for this option
      label: string,
      // Unique string code makes the option easier to reference and identify
      code: string,
      // Icons that may be displayed alongside the option
      icon?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // The health rating from 0-5
    health?: number | null,
    // Budget Rating
    budget?: number | null,
    // Utensils needed for the recipe
    utensils?: Array< string | null > | null,
    // List of ingredients
    ingredients?:  Array< {
      __typename: "RecipeIngredient",
      id: string,
      name: string,
      quantity?: string | null,
      unitOfMeasure?: string | null,
      category?: string | null,
      pantryItem?: boolean | null,
      ingredientID?: string | null,
    } | null > | null,
    recipeIngredients?:  {
      __typename: "ModelRecipeIngredientsGroupConnection",
      items:  Array< {
        __typename: "RecipeIngredientsGroup",
        id: string,
        recipeID: string,
        // Optional display string for this ingredient
        display?: string | null,
        // The linked recipe
        recipe?:  {
          __typename: "Recipe",
          id: string,
          // Habitat ID for a recipe. This means the recipe is linked to a specific household
          habitatID?: string | null,
          // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
          readGroups?: Array< string | null > | null,
          name: string,
          searchField?: string | null,
          emoji?: string | null,
          // A short description or introduction to the dish
          description?: string | null,
          imageUrl?: string | null,
          // Indicates the recipe is still in development
          inProgress?: boolean | null,
          imageID?: string | null,
          image?:  {
            __typename: "Image",
            id: string,
            name: string,
            habitatID?: string | null,
            readGroups?: Array< string | null > | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
          mealTypes?: Array< MealType | null > | null,
          dishTypeID?: string | null,
          // The type or category of the dish
          dishType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          dishTypeIDs?: Array< string | null > | null,
          skillLevelID?: string | null,
          // The recommended skill level for the dish
          skillLevel?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          servingSizeID?: string | null,
          // How many servings this recipe provides
          servingSize?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          cuisineTypeID?: string | null,
          // How many servings this recipe provides
          cuisineType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          familyfriendlyTypeID?: string | null,
          // How many servings this recipe provides
          familyfriendlyType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          textureTypeID?: string | null,
          // How many servings this recipe provides
          textureType?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          specialDietIDs?: Array< string | null > | null,
          specialDiets?:  {
            __typename: "ModelRecordOptionConnection",
            nextToken?: string | null,
          } | null,
          prepTimeID?: string | null,
          // Preparation time selection
          prepTime?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // Preparation steps
          prepNotes?:  Array< {
            __typename: "PreparationNote",
            id: string,
            title?: string | null,
            icon?: string | null,
            description: string,
          } | null > | null,
          mainIngredientID?: string | null,
          // The primary ingredient of the dish
          mainIngredient?:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          // The health rating from 0-5
          health?: number | null,
          // Budget Rating
          budget?: number | null,
          // Utensils needed for the recipe
          utensils?: Array< string | null > | null,
          // List of ingredients
          ingredients?:  Array< {
            __typename: "RecipeIngredient",
            id: string,
            name: string,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            category?: string | null,
            pantryItem?: boolean | null,
            ingredientID?: string | null,
          } | null > | null,
          recipeIngredients?:  {
            __typename: "ModelRecipeIngredientsGroupConnection",
            nextToken?: string | null,
          } | null,
          // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
          allergyIDs?: Array< string | null > | null,
          // The default number of servings this recipe is for
          default_servings?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        ingredientID?: string | null,
        ingredient?:  {
          __typename: "ModelIngredientItemConnection",
          items:  Array< {
            __typename: "IngredientItem",
            id: string,
            name: string,
            groupID: string,
            recipeGroupID?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        pantryItem?: boolean | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
    allergyIDs?: Array< string | null > | null,
    // The default number of servings this recipe is for
    default_servings?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRecipeIngredientsGroupSubscriptionVariables = {
};

export type OnCreateRecipeIngredientsGroupSubscription = {
  onCreateRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecipeIngredientsGroupSubscriptionVariables = {
};

export type OnUpdateRecipeIngredientsGroupSubscription = {
  onUpdateRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecipeIngredientsGroupSubscriptionVariables = {
};

export type OnDeleteRecipeIngredientsGroupSubscription = {
  onDeleteRecipeIngredientsGroup?:  {
    __typename: "RecipeIngredientsGroup",
    id: string,
    recipeID: string,
    // Optional display string for this ingredient
    display?: string | null,
    // The linked recipe
    recipe?:  {
      __typename: "Recipe",
      id: string,
      // Habitat ID for a recipe. This means the recipe is linked to a specific household
      habitatID?: string | null,
      // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
      readGroups?: Array< string | null > | null,
      name: string,
      searchField?: string | null,
      emoji?: string | null,
      // A short description or introduction to the dish
      description?: string | null,
      imageUrl?: string | null,
      // Indicates the recipe is still in development
      inProgress?: boolean | null,
      imageID?: string | null,
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
      mealTypes?: Array< MealType | null > | null,
      dishTypeID?: string | null,
      // The type or category of the dish
      dishType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      dishTypeIDs?: Array< string | null > | null,
      skillLevelID?: string | null,
      // The recommended skill level for the dish
      skillLevel?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      servingSizeID?: string | null,
      // How many servings this recipe provides
      servingSize?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cuisineTypeID?: string | null,
      // How many servings this recipe provides
      cuisineType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      familyfriendlyTypeID?: string | null,
      // How many servings this recipe provides
      familyfriendlyType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      textureTypeID?: string | null,
      // How many servings this recipe provides
      textureType?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      specialDietIDs?: Array< string | null > | null,
      specialDiets?:  {
        __typename: "ModelRecordOptionConnection",
        items:  Array< {
          __typename: "RecordOption",
          id: string,
          recordID: string,
          optionID: string,
          option:  {
            __typename: "Option",
            id: string,
            // This type of option. This can be used to determine which dropdowns or lists the option can be used in
            type: string,
            // The displayed text for this option
            label: string,
            // Unique string code makes the option easier to reference and identify
            code: string,
            // Icons that may be displayed alongside the option
            icon?: string | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      prepTimeID?: string | null,
      // Preparation time selection
      prepTime?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Preparation steps
      prepNotes?:  Array< {
        __typename: "PreparationNote",
        id: string,
        title?: string | null,
        icon?: string | null,
        description: string,
      } | null > | null,
      mainIngredientID?: string | null,
      // The primary ingredient of the dish
      mainIngredient?:  {
        __typename: "Option",
        id: string,
        // This type of option. This can be used to determine which dropdowns or lists the option can be used in
        type: string,
        // The displayed text for this option
        label: string,
        // Unique string code makes the option easier to reference and identify
        code: string,
        // Icons that may be displayed alongside the option
        icon?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // The health rating from 0-5
      health?: number | null,
      // Budget Rating
      budget?: number | null,
      // Utensils needed for the recipe
      utensils?: Array< string | null > | null,
      // List of ingredients
      ingredients?:  Array< {
        __typename: "RecipeIngredient",
        id: string,
        name: string,
        quantity?: string | null,
        unitOfMeasure?: string | null,
        category?: string | null,
        pantryItem?: boolean | null,
        ingredientID?: string | null,
      } | null > | null,
      recipeIngredients?:  {
        __typename: "ModelRecipeIngredientsGroupConnection",
        items:  Array< {
          __typename: "RecipeIngredientsGroup",
          id: string,
          recipeID: string,
          // Optional display string for this ingredient
          display?: string | null,
          // The linked recipe
          recipe?:  {
            __typename: "Recipe",
            id: string,
            // Habitat ID for a recipe. This means the recipe is linked to a specific household
            habitatID?: string | null,
            // Allows for certain groups to be able to read the recipe. Can be used for making public or shared cohort recipes
            readGroups?: Array< string | null > | null,
            name: string,
            searchField?: string | null,
            emoji?: string | null,
            // A short description or introduction to the dish
            description?: string | null,
            imageUrl?: string | null,
            // Indicates the recipe is still in development
            inProgress?: boolean | null,
            imageID?: string | null,
            // The meal types this recipe is suitable for e.g. breakfast, lunch, dinner
            mealTypes?: Array< MealType | null > | null,
            dishTypeID?: string | null,
            dishTypeIDs?: Array< string | null > | null,
            skillLevelID?: string | null,
            servingSizeID?: string | null,
            cuisineTypeID?: string | null,
            familyfriendlyTypeID?: string | null,
            textureTypeID?: string | null,
            specialDietIDs?: Array< string | null > | null,
            prepTimeID?: string | null,
            mainIngredientID?: string | null,
            // The health rating from 0-5
            health?: number | null,
            // Budget Rating
            budget?: number | null,
            // Utensils needed for the recipe
            utensils?: Array< string | null > | null,
            // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
            allergyIDs?: Array< string | null > | null,
            // The default number of servings this recipe is for
            default_servings?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          ingredientID?: string | null,
          ingredient?:  {
            __typename: "ModelIngredientItemConnection",
            nextToken?: string | null,
          } | null,
          quantity?: string | null,
          unitOfMeasure?: string | null,
          pantryItem?: boolean | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      // List of allergy IDS. Not currently using a many2many field for this, as it doesn't provide much value
      allergyIDs?: Array< string | null > | null,
      // The default number of servings this recipe is for
      default_servings?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    ingredientID?: string | null,
    ingredient?:  {
      __typename: "ModelIngredientItemConnection",
      items:  Array< {
        __typename: "IngredientItem",
        id: string,
        name: string,
        groupID: string,
        group?:  {
          __typename: "IngredientGroup",
          id: string,
          name: string,
          createdAt: string,
          updatedAt: string,
        } | null,
        recipeGroupID?: string | null,
        recipeGroup?:  {
          __typename: "ModelRecipeIngredientsGroupConnection",
          items:  Array< {
            __typename: "RecipeIngredientsGroup",
            id: string,
            recipeID: string,
            // Optional display string for this ingredient
            display?: string | null,
            ingredientID?: string | null,
            quantity?: string | null,
            unitOfMeasure?: string | null,
            pantryItem?: boolean | null,
            createdAt: string,
            updatedAt: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    quantity?: string | null,
    unitOfMeasure?: string | null,
    pantryItem?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateScheduledMessageSubscriptionVariables = {
};

export type OnCreateScheduledMessageSubscription = {
  onCreateScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateScheduledMessageSubscriptionVariables = {
};

export type OnUpdateScheduledMessageSubscription = {
  onUpdateScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteScheduledMessageSubscriptionVariables = {
};

export type OnDeleteScheduledMessageSubscription = {
  onDeleteScheduledMessage?:  {
    __typename: "ScheduledMessage",
    id: string,
    dialogTrigger: string,
    rrule?: string | null,
    periodOffset?: number | null,
    scheduledDate?: string | null,
    scheduledTime?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStickyNoteSubscriptionVariables = {
};

export type OnCreateStickyNoteSubscription = {
  onCreateStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateStickyNoteSubscriptionVariables = {
};

export type OnUpdateStickyNoteSubscription = {
  onUpdateStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteStickyNoteSubscriptionVariables = {
};

export type OnDeleteStickyNoteSubscription = {
  onDeleteStickyNote?:  {
    __typename: "StickyNote",
    id: string,
    // Habitat the note belongs to
    habitatID?: string | null,
    // Content of the note
    content?: string | null,
    // Color of the note
    color?: string | null,
    // ID Person who created the note
    ownerID?: string | null,
    // Record of person who created the note
    owner?:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // IDs of the users this note has been shared with
    sharedWithIDs?: Array< string | null > | null,
    // Records of when a user has acknowledged the sticky note. e.g. clicked the thumb button on the note
    acknowledgements?:  Array< {
      __typename: "StickyNoteAcknowledgement",
      user_id?: string | null,
      date?: string | null,
    } | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSystemPropertySubscriptionVariables = {
};

export type OnCreateSystemPropertySubscription = {
  onCreateSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSystemPropertySubscriptionVariables = {
};

export type OnUpdateSystemPropertySubscription = {
  onUpdateSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSystemPropertySubscriptionVariables = {
};

export type OnDeleteSystemPropertySubscription = {
  onDeleteSystemProperty?:  {
    __typename: "SystemProperty",
    // Primary Key
    name: string,
    // Display Label of the Property
    label: string,
    // Description of the property
    description?: string | null,
    // Value of the property
    value?: string | null,
    // Groups allowed to read this
    read_groups?: Array< string | null > | null,
    // System property is publicly viewable
    public?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTaskListSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateTaskListSubscription = {
  onCreateTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTaskListSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateTaskListSubscription = {
  onUpdateTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTaskListSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteTaskListSubscription = {
  onDeleteTaskList?:  {
    __typename: "TaskList",
    id: string,
    habitatID: string,
    emoji?: string | null,
    title: string,
    type?: TaskListType | null,
    // Indicates that this list is the primary ingredients list.
    // This is the list that will have ingredients added to it from recipes etc
    primaryIngredientList?: boolean | null,
    top?: boolean | null,
    favourite?: boolean | null,
    isAkinList?: boolean | null,
    // who is it for
    principal:  {
      __typename: "User",
      // The ID of the user
      id: string,
      // The cognito user sub
      sub: string,
      // Name of the user
      name: string,
      // Location of the user
      location?: string | null,
      // The username of the user. This should come from the cognito user pool
      username: string,
      // Indicates that this user is the primary habitat user. This user cannot be deleted.
      primary?: boolean | null,
      // The Habitat the user belongs to. May not be set when account is still being set up
      habitatID?: string | null,
      role?: UserRole | null,
      // Email of the user
      email?: string | null,
      // The users phone number
      phoneNumber?: string | null,
      NDISAccountName?: string | null,
      NDISNumber?: string | null,
      birthday?: string | null,
      planManagerName?: string | null,
      planManagerEmail?: string | null,
      emailVerified?: boolean | null,
      carerPhone?: string | null,
      carerName?: string | null,
      supportWorkerPhone?: string | null,
      supportWorkerName?: string | null,
      contacts?: Array< string | null > | null,
      favouriteContacts?: Array< string | null > | null,
      address?:  {
        __typename: "Address",
        type?: string | null,
        street?: string | null,
        city?: string | null,
        state?: string | null,
        postcode?: string | null,
        country?: string | null,
      } | null,
      // Profile color to be displayed with the users image
      profileColor?: string | null,
      // Selected Profile Picture - Stock Images from akin
      profilePicture?: string | null,
      imageID?: string | null,
      // Custom image uploaded from the device
      image?:  {
        __typename: "Image",
        id: string,
        name: string,
        habitatID?: string | null,
        readGroups?: Array< string | null > | null,
        // Data for linking to the S3 image
        data:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      // Public Image URL
      customPictureURL?: string | null,
      // Preferences linked to device system settings
      systemPreferences?:  {
        __typename: "SystemPreferences",
        androidNotificationSoundID?: string | null,
        androidAlarmSoundID?: string | null,
      } | null,
      scheduledMessages?:  {
        __typename: "ModelUserScheduledMessageConnection",
        items:  Array< {
          __typename: "UserScheduledMessage",
          id: string,
          userID: string,
          habitatID: string,
          scheduledMessageID: string,
          scheduledMessage?:  {
            __typename: "ScheduledMessage",
            id: string,
            dialogTrigger: string,
            rrule?: string | null,
            periodOffset?: number | null,
            scheduledDate?: string | null,
            scheduledTime?: string | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          scheduledDate?: string | null,
          scheduledTime: string,
          answered?: boolean | null,
          delayCount?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      endpointIds?: Array< string | null > | null,
      // Flag for whether the user has completed the meal onboarding
      hasCompletedMealOnboarding?: boolean | null,
      // Flag for whether the user has viewed the meals section of the app
      hasViewedMealSection?: boolean | null,
      // Flag for whether the user has viewed the goal section of the app
      hasViewedGoalSection?: boolean | null,
      // IDs of recipe preference options
      recipePreferenceOptionIDs?: Array< string | null > | null,
      // Token used when sending a link to the onboarding process
      onboardingToken?: string | null,
      // Flag for whether the user has been onboarded
      hasOnboarded?: boolean | null,
      // Flag for if the user has skipped the onboarding wizard
      skippedOnboardingWizard?: boolean | null,
      // The user's recipe choices in onboarding. A list of recipe IDs
      onboardingRecipeChoices?: Array< string | null > | null,
      // Dashboard Layout Preset
      dashboardLayoutPreset?: string | null,
      chatApplicationId?: string | null,
      people?: number | null,
      budget?: number | null,
      time_and_effort?: number | null,
      dietary_balance?: number | null,
      allergies?: Array< string | null > | null,
      prepTime?: number | null,
      avoidances?:  Array< {
        __typename: "FoodAvoidance",
        category?: string | null,
        degree?: number | null,
      } | null > | null,
      skillLevel?: number | null,
      // Indicates that this is profile is for a child
      is_child_profile?: boolean | null,
      // If defined, this is passed to chat system to enable user to use generative AI as a fallback
      use_generative_ai?:  {
        __typename: "UseGenerativeAIOptions",
        name?: string | null,
        model?: string | null,
        max_tokens?: number | null,
        temperature?: number | null,
      } | null,
      // List of the users favourite recipe IDs
      favourite_recipe_ids?: Array< string | null > | null,
      // ID of the linked contact record
      contact_id?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    principalID: string,
    participantIDS?: Array< string | null > | null,
    // what do you need to bring
    checklist?: string | null,
    image?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    // The ID of the user
    id: string,
    // The cognito user sub
    sub: string,
    // Name of the user
    name: string,
    // Location of the user
    location?: string | null,
    // The username of the user. This should come from the cognito user pool
    username: string,
    // Indicates that this user is the primary habitat user. This user cannot be deleted.
    primary?: boolean | null,
    // The Habitat the user belongs to. May not be set when account is still being set up
    habitatID?: string | null,
    role?: UserRole | null,
    // Email of the user
    email?: string | null,
    // The users phone number
    phoneNumber?: string | null,
    NDISAccountName?: string | null,
    NDISNumber?: string | null,
    birthday?: string | null,
    planManagerName?: string | null,
    planManagerEmail?: string | null,
    emailVerified?: boolean | null,
    carerPhone?: string | null,
    carerName?: string | null,
    supportWorkerPhone?: string | null,
    supportWorkerName?: string | null,
    contacts?: Array< string | null > | null,
    favouriteContacts?: Array< string | null > | null,
    address?:  {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null,
    // Profile color to be displayed with the users image
    profileColor?: string | null,
    // Selected Profile Picture - Stock Images from akin
    profilePicture?: string | null,
    imageID?: string | null,
    // Custom image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    customPictureURL?: string | null,
    // Preferences linked to device system settings
    systemPreferences?:  {
      __typename: "SystemPreferences",
      androidNotificationSoundID?: string | null,
      androidAlarmSoundID?: string | null,
    } | null,
    scheduledMessages?:  {
      __typename: "ModelUserScheduledMessageConnection",
      items:  Array< {
        __typename: "UserScheduledMessage",
        id: string,
        userID: string,
        habitatID: string,
        scheduledMessageID: string,
        scheduledMessage?:  {
          __typename: "ScheduledMessage",
          id: string,
          dialogTrigger: string,
          rrule?: string | null,
          periodOffset?: number | null,
          scheduledDate?: string | null,
          scheduledTime?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        scheduledDate?: string | null,
        scheduledTime: string,
        answered?: boolean | null,
        delayCount?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    endpointIds?: Array< string | null > | null,
    // Flag for whether the user has completed the meal onboarding
    hasCompletedMealOnboarding?: boolean | null,
    // Flag for whether the user has viewed the meals section of the app
    hasViewedMealSection?: boolean | null,
    // Flag for whether the user has viewed the goal section of the app
    hasViewedGoalSection?: boolean | null,
    // IDs of recipe preference options
    recipePreferenceOptionIDs?: Array< string | null > | null,
    // Token used when sending a link to the onboarding process
    onboardingToken?: string | null,
    // Flag for whether the user has been onboarded
    hasOnboarded?: boolean | null,
    // Flag for if the user has skipped the onboarding wizard
    skippedOnboardingWizard?: boolean | null,
    // The user's recipe choices in onboarding. A list of recipe IDs
    onboardingRecipeChoices?: Array< string | null > | null,
    // Dashboard Layout Preset
    dashboardLayoutPreset?: string | null,
    chatApplicationId?: string | null,
    people?: number | null,
    budget?: number | null,
    time_and_effort?: number | null,
    dietary_balance?: number | null,
    allergies?: Array< string | null > | null,
    prepTime?: number | null,
    avoidances?:  Array< {
      __typename: "FoodAvoidance",
      category?: string | null,
      degree?: number | null,
    } | null > | null,
    skillLevel?: number | null,
    // Indicates that this is profile is for a child
    is_child_profile?: boolean | null,
    // If defined, this is passed to chat system to enable user to use generative AI as a fallback
    use_generative_ai?:  {
      __typename: "UseGenerativeAIOptions",
      name?: string | null,
      model?: string | null,
      max_tokens?: number | null,
      temperature?: number | null,
    } | null,
    // List of the users favourite recipe IDs
    favourite_recipe_ids?: Array< string | null > | null,
    // ID of the linked contact record
    contact_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateContactSubscriptionVariables = {
};

export type OnCreateContactSubscription = {
  onCreateContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateContactSubscriptionVariables = {
};

export type OnUpdateContactSubscription = {
  onUpdateContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteContactSubscriptionVariables = {
};

export type OnDeleteContactSubscription = {
  onDeleteContact?:  {
    __typename: "Contact",
    id: string,
    habitatID: string,
    name: string,
    // Don't use the type field anymore
    type?: string | null,
    tags?: Array< string | null > | null,
    phoneNumbers?:  Array< {
      __typename: "PhoneNumber",
      number: string,
      type: string,
    } | null > | null,
    emailAddresses?: Array< string | null > | null,
    addresses?:  Array< {
      __typename: "Address",
      type?: string | null,
      street?: string | null,
      city?: string | null,
      state?: string | null,
      postcode?: string | null,
      country?: string | null,
    } | null > | null,
    notes?: Array< string | null > | null,
    // Profile color to be displayed with the contact's image
    contactColor?: string | null,
    // Selected Contact Picture - Stock Images from akin
    stockImage?: string | null,
    imageID?: string | null,
    // Custom contact image uploaded from the device
    image?:  {
      __typename: "Image",
      id: string,
      name: string,
      habitatID?: string | null,
      readGroups?: Array< string | null > | null,
      // Data for linking to the S3 image
      data:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    // Public Image URL
    publicImageURL?: string | null,
    // ID of the linked user record
    user_id?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserScheduledMessageSubscriptionVariables = {
};

export type OnCreateUserScheduledMessageSubscription = {
  onCreateUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserScheduledMessageSubscriptionVariables = {
};

export type OnUpdateUserScheduledMessageSubscription = {
  onUpdateUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserScheduledMessageSubscriptionVariables = {
};

export type OnDeleteUserScheduledMessageSubscription = {
  onDeleteUserScheduledMessage?:  {
    __typename: "UserScheduledMessage",
    id: string,
    userID: string,
    habitatID: string,
    scheduledMessageID: string,
    scheduledMessage?:  {
      __typename: "ScheduledMessage",
      id: string,
      dialogTrigger: string,
      rrule?: string | null,
      periodOffset?: number | null,
      scheduledDate?: string | null,
      scheduledTime?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    scheduledDate?: string | null,
    scheduledTime: string,
    answered?: boolean | null,
    delayCount?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};
